[
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/GrafanaConfigDto.schema.json",
    "fileMatch": ["a://b/GrafanaConfigDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/GrafanaConfigDto.schema.json",
      "title": "GrafanaConfigDto",
      "type": "object",
      "properties": {
        "url": {
          "type": "string",
          "description": "Base URL of the Grafana instance",
          "example": "http://localhost:3001"
        },
        "tempoUid": {
          "type": "string",
          "description": "UID of the Tempo data source in Grafana",
          "example": "tempo"
        },
        "lokiUid": {
          "type": "string",
          "description": "UID of the Loki data source in Grafana",
          "example": "loki"
        }
      },
      "required": ["tempoUid", "lokiUid"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/FrontendConfigResponseDto.schema.json",
    "fileMatch": ["a://b/FrontendConfigResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/FrontendConfigResponseDto.schema.json",
      "title": "FrontendConfigResponseDto",
      "type": "object",
      "properties": {
        "grafana": {
          "description": "Grafana observability configuration",
          "allOf": [
            {
              "$ref": "./GrafanaConfigDto.schema.json"
            }
          ]
        }
      },
      "required": ["grafana"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/RoleDto.schema.json",
    "fileMatch": ["a://b/RoleDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/RoleDto.schema.json",
      "title": "RoleDto",
      "type": "object",
      "properties": {
        "role": {
          "enum": [
            "presentation:manage",
            "presentation:request",
            "issuance:manage",
            "issuance:offer",
            "clients:manage",
            "users:manage",
            "tenants:manage",
            "registrar:manage"
          ],
          "type": "string",
          "description": "OAuth2 roles",
          "example": "issuance:manage"
        }
      },
      "required": ["role"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ClientCredentialsDto.schema.json",
    "fileMatch": ["a://b/ClientCredentialsDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ClientCredentialsDto.schema.json",
      "title": "ClientCredentialsDto",
      "type": "object",
      "properties": {
        "grant_type": {
          "type": "string",
          "default": "client_credentials"
        },
        "client_id": {
          "type": "string"
        },
        "client_secret": {
          "type": "string"
        }
      },
      "required": ["client_id", "client_secret"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/TokenResponse.schema.json",
    "fileMatch": ["a://b/TokenResponse*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/TokenResponse.schema.json",
      "title": "TokenResponse",
      "type": "object",
      "properties": {
        "access_token": {
          "type": "string"
        },
        "refresh_token": {
          "type": "string"
        },
        "token_type": {
          "type": "string"
        },
        "expires_in": {
          "type": "number"
        }
      },
      "required": ["access_token", "token_type", "expires_in"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ImportTenantDto.schema.json",
    "fileMatch": ["a://b/ImportTenantDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ImportTenantDto.schema.json",
      "title": "ImportTenantDto",
      "type": "object",
      "properties": {
        "name": {
          "type": "string",
          "description": "The name of the tenant."
        },
        "description": {
          "type": "string",
          "description": "The description of the tenant."
        }
      },
      "required": ["name"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/SessionStorageConfig.schema.json",
    "fileMatch": ["a://b/SessionStorageConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/SessionStorageConfig.schema.json",
      "title": "SessionStorageConfig",
      "type": "object",
      "properties": {
        "ttlSeconds": {
          "type": "number",
          "description": "Time-to-live for sessions in seconds. If not set, uses global SESSION_TTL.",
          "example": 86400,
          "minimum": 60
        },
        "cleanupMode": {
          "type": "string",
          "description": "Cleanup mode: 'full' deletes everything, 'anonymize' keeps metadata but removes PII.",
          "enum": ["full", "anonymize"],
          "default": "full"
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/StatusListConfig.schema.json",
    "fileMatch": ["a://b/StatusListConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/StatusListConfig.schema.json",
      "title": "StatusListConfig",
      "type": "object",
      "properties": {
        "capacity": {
          "type": "number",
          "description": "The capacity of the status list. If not set, uses global STATUS_CAPACITY.",
          "example": 10000,
          "minimum": 100
        },
        "bits": {
          "type": "number",
          "description": "Bits per status entry: 1 (valid/revoked), 2 (with suspended), 4/8 (extended). If not set, uses global STATUS_BITS.",
          "enum": [1, 2, 4, 8],
          "default": 1
        },
        "ttl": {
          "type": "number",
          "description": "TTL in seconds for the status list JWT. If not set, uses global STATUS_TTL.",
          "example": 3600,
          "minimum": 60
        },
        "immediateUpdate": {
          "type": "boolean",
          "description": "If true, regenerate JWT immediately on status changes. If false (default), use lazy regeneration on TTL expiry.",
          "default": false
        },
        "enableAggregation": {
          "type": "boolean",
          "description": "If true, include aggregation_uri in status list JWTs for pre-fetching support (default: true).",
          "default": true
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/TenantEntity.schema.json",
    "fileMatch": ["a://b/TenantEntity*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/TenantEntity.schema.json",
      "title": "TenantEntity",
      "type": "object",
      "properties": {
        "sessionConfig": {
          "nullable": true,
          "description": "Session storage configuration for this tenant. Controls TTL and cleanup behavior.",
          "type": "object",
          "allOf": [
            {
              "$ref": "./SessionStorageConfig.schema.json"
            }
          ]
        },
        "statusListConfig": {
          "nullable": true,
          "description": "Status list configuration for this tenant. Only affects newly created status lists.",
          "type": "object",
          "allOf": [
            {
              "$ref": "./StatusListConfig.schema.json"
            }
          ]
        },
        "id": {
          "type": "string",
          "description": "The unique identifier for the tenant."
        },
        "name": {
          "type": "string",
          "description": "The name of the tenant."
        },
        "description": {
          "type": "string",
          "description": "The description of the tenant."
        },
        "status": {
          "type": "string",
          "description": "The current status of the tenant."
        },
        "clients": {
          "description": "The clients associated with the tenant.",
          "type": "array",
          "items": {
            "$ref": "./ClientEntity.schema.json"
          }
        }
      },
      "required": ["id", "name", "status", "clients"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ClientEntity.schema.json",
    "fileMatch": ["a://b/ClientEntity*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ClientEntity.schema.json",
      "title": "ClientEntity",
      "type": "object",
      "properties": {
        "allowedPresentationConfigs": {
          "nullable": true,
          "description": "List of presentation config IDs this client can use. If empty/null, all configs are allowed.",
          "example": ["age-verification", "kyc-basic"],
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "allowedIssuanceConfigs": {
          "nullable": true,
          "description": "List of issuance config IDs this client can use. If empty/null, all configs are allowed.",
          "example": ["pid", "mdl"],
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "clientId": {
          "type": "string",
          "description": "The unique identifier for the client."
        },
        "secret": {
          "type": "string",
          "description": "The secret key for the client."
        },
        "tenantId": {
          "type": "string",
          "description": "The unique identifier for the tenant that the client belongs to. Only null for accounts that manage tenants, that do not belong to a client"
        },
        "description": {
          "type": "string",
          "description": "The description of the client."
        },
        "roles": {
          "description": "The roles assigned to the client.",
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "presentation:manage",
              "presentation:request",
              "issuance:manage",
              "issuance:offer",
              "clients:manage",
              "users:manage",
              "tenants:manage",
              "registrar:manage"
            ]
          }
        },
        "tenant": {
          "description": "The tenant that the client belongs to.",
          "allOf": [
            {
              "$ref": "./TenantEntity.schema.json"
            }
          ]
        }
      },
      "required": ["clientId", "roles"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/CreateTenantDto.schema.json",
    "fileMatch": ["a://b/CreateTenantDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/CreateTenantDto.schema.json",
      "title": "CreateTenantDto",
      "type": "object",
      "properties": {
        "statusListConfig": {
          "nullable": true,
          "description": "Status list configuration for this tenant. Only affects newly created status lists.",
          "type": "object",
          "allOf": [
            {
              "$ref": "./StatusListConfig.schema.json"
            }
          ]
        },
        "id": {
          "type": "string",
          "description": "The unique identifier for the tenant."
        },
        "name": {
          "type": "string",
          "description": "The name of the tenant."
        },
        "description": {
          "type": "string",
          "description": "The description of the tenant."
        },
        "sessionConfig": {
          "description": "Session storage configuration. Controls TTL and cleanup behavior.",
          "allOf": [
            {
              "$ref": "./SessionStorageConfig.schema.json"
            }
          ]
        },
        "roles": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "presentation:manage",
              "presentation:request",
              "issuance:manage",
              "issuance:offer",
              "clients:manage",
              "users:manage",
              "tenants:manage",
              "registrar:manage"
            ]
          }
        }
      },
      "required": ["id", "name"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/UpdateTenantDto.schema.json",
    "fileMatch": ["a://b/UpdateTenantDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/UpdateTenantDto.schema.json",
      "title": "UpdateTenantDto",
      "type": "object",
      "properties": {
        "statusListConfig": {
          "nullable": true,
          "description": "Status list configuration for this tenant. Only affects newly created status lists.",
          "type": "object",
          "allOf": [
            {
              "$ref": "./StatusListConfig.schema.json"
            }
          ]
        },
        "name": {
          "type": "string",
          "description": "The name of the tenant."
        },
        "description": {
          "type": "string",
          "description": "The description of the tenant."
        },
        "sessionConfig": {
          "description": "Session storage configuration. Controls TTL and cleanup behavior.",
          "allOf": [
            {
              "$ref": "./SessionStorageConfig.schema.json"
            }
          ]
        },
        "roles": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "presentation:manage",
              "presentation:request",
              "issuance:manage",
              "issuance:offer",
              "clients:manage",
              "users:manage",
              "tenants:manage",
              "registrar:manage"
            ]
          }
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/AuditLogResponseDto.schema.json",
    "fileMatch": ["a://b/AuditLogResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/AuditLogResponseDto.schema.json",
      "title": "AuditLogResponseDto",
      "type": "object",
      "properties": {
        "id": {
          "type": "string"
        },
        "tenantId": {
          "type": "string"
        },
        "actionType": {
          "enum": [
            "tenant_created",
            "tenant_updated",
            "tenant_deleted",
            "presentation_config_created",
            "presentation_config_updated",
            "presentation_config_deleted",
            "issuance_config_updated",
            "credential_config_created",
            "credential_config_updated",
            "credential_config_deleted",
            "status_list_config_updated",
            "status_list_config_reset",
            "webhook_endpoint_created",
            "webhook_endpoint_updated",
            "webhook_endpoint_deleted",
            "attribute_provider_created",
            "attribute_provider_updated",
            "attribute_provider_deleted"
          ],
          "type": "string"
        },
        "actorType": {
          "enum": ["user", "client", "system"],
          "type": "string"
        },
        "actorId": {
          "type": "string"
        },
        "actorDisplay": {
          "type": "string"
        },
        "changedFields": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "before": {
          "type": "object",
          "additionalProperties": true
        },
        "after": {
          "type": "object",
          "additionalProperties": true
        },
        "requestId": {
          "type": "string"
        },
        "timestamp": {
          "format": "date-time",
          "type": "string"
        }
      },
      "required": ["id", "tenantId", "actionType", "actorType", "timestamp"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ClientSecretResponseDto.schema.json",
    "fileMatch": ["a://b/ClientSecretResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ClientSecretResponseDto.schema.json",
      "title": "ClientSecretResponseDto",
      "type": "object",
      "properties": {
        "secret": {
          "type": "string"
        }
      },
      "required": ["secret"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/UpdateClientDto.schema.json",
    "fileMatch": ["a://b/UpdateClientDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/UpdateClientDto.schema.json",
      "title": "UpdateClientDto",
      "type": "object",
      "properties": {
        "allowedPresentationConfigs": {
          "nullable": true,
          "description": "List of presentation config IDs this client can use. If empty/null, all configs are allowed.",
          "example": ["age-verification", "kyc-basic"],
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "allowedIssuanceConfigs": {
          "nullable": true,
          "description": "List of issuance config IDs this client can use. If empty/null, all configs are allowed.",
          "example": ["pid", "mdl"],
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "description": {
          "type": "string",
          "description": "The description of the client."
        },
        "roles": {
          "description": "The roles assigned to the client.",
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "presentation:manage",
              "presentation:request",
              "issuance:manage",
              "issuance:offer",
              "clients:manage",
              "users:manage",
              "tenants:manage",
              "registrar:manage"
            ]
          }
        }
      },
      "required": ["roles"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/CreateClientDto.schema.json",
    "fileMatch": ["a://b/CreateClientDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/CreateClientDto.schema.json",
      "title": "CreateClientDto",
      "type": "object",
      "properties": {
        "allowedPresentationConfigs": {
          "nullable": true,
          "description": "List of presentation config IDs this client can use. If empty/null, all configs are allowed.",
          "example": ["age-verification", "kyc-basic"],
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "allowedIssuanceConfigs": {
          "nullable": true,
          "description": "List of issuance config IDs this client can use. If empty/null, all configs are allowed.",
          "example": ["pid", "mdl"],
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "clientId": {
          "type": "string",
          "description": "The unique identifier for the client."
        },
        "secret": {
          "type": "string",
          "description": "The secret key for the client."
        },
        "description": {
          "type": "string",
          "description": "The description of the client."
        },
        "roles": {
          "description": "The roles assigned to the client.",
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "presentation:manage",
              "presentation:request",
              "issuance:manage",
              "issuance:offer",
              "clients:manage",
              "users:manage",
              "tenants:manage",
              "registrar:manage"
            ]
          }
        }
      },
      "required": ["clientId", "roles"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/StatusListImportDto.schema.json",
    "fileMatch": ["a://b/StatusListImportDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/StatusListImportDto.schema.json",
      "title": "StatusListImportDto",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Unique identifier for the status list"
        },
        "credentialConfigurationId": {
          "type": "string",
          "nullable": true,
          "description": "Credential configuration ID to bind this list exclusively to. Leave empty for a shared list.",
          "example": "org.iso.18013.5.1.mDL"
        },
        "keyChainId": {
          "type": "string",
          "description": "Key chain ID to use for signing. Leave empty to use the tenant's default StatusList key chain.",
          "example": "my-status-list-keychain"
        },
        "capacity": {
          "type": "number",
          "description": "Capacity of the status list. If not provided, uses tenant or global defaults.",
          "minimum": 100,
          "example": 10000
        },
        "bits": {
          "description": "Bits per status value. If not provided, uses tenant or global defaults.",
          "enum": [1, 2, 4, 8],
          "type": "number",
          "example": 1
        }
      },
      "required": ["id"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/StatusListAggregationDto.schema.json",
    "fileMatch": ["a://b/StatusListAggregationDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/StatusListAggregationDto.schema.json",
      "title": "StatusListAggregationDto",
      "type": "object",
      "properties": {
        "status_lists": {
          "description": "Array of status list token URIs",
          "example": [
            "https://example.com/tenant-123/status-management/status-list/list-1",
            "https://example.com/tenant-123/status-management/status-list/list-2"
          ],
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": ["status_lists"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/UpdateStatusListConfigDto.schema.json",
    "fileMatch": ["a://b/UpdateStatusListConfigDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/UpdateStatusListConfigDto.schema.json",
      "title": "UpdateStatusListConfigDto",
      "type": "object",
      "properties": {
        "capacity": {
          "type": "number",
          "nullable": true,
          "description": "The capacity of the status list. Set to null to reset to global default.",
          "minimum": 100,
          "example": 10000
        },
        "bits": {
          "nullable": true,
          "description": "Bits per status entry. Set to null to reset to global default.",
          "enum": [1, 2, 4, 8],
          "type": "number"
        },
        "ttl": {
          "type": "number",
          "nullable": true,
          "description": "TTL in seconds for the status list JWT. Set to null to reset to global default.",
          "minimum": 60,
          "example": 3600
        },
        "immediateUpdate": {
          "type": "boolean",
          "nullable": true,
          "description": "If true, regenerate JWT on every status change. Set to null to reset to default (false)."
        },
        "enableAggregation": {
          "type": "boolean",
          "nullable": true,
          "description": "If true, include aggregation_uri in status list JWTs for pre-fetching support. Set to null to reset to default (true)."
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/StatusListResponseDto.schema.json",
    "fileMatch": ["a://b/StatusListResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/StatusListResponseDto.schema.json",
      "title": "StatusListResponseDto",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Unique identifier for the status list",
          "example": "550e8400-e29b-41d4-a716-446655440000"
        },
        "tenantId": {
          "type": "string",
          "description": "The tenant ID",
          "example": "root"
        },
        "credentialConfigurationId": {
          "type": "string",
          "nullable": true,
          "description": "Credential configuration ID this list is bound to. Null means shared.",
          "example": "org.iso.18013.5.1.mDL"
        },
        "keyChainId": {
          "type": "string",
          "nullable": true,
          "description": "Key chain ID used for signing. Null means using the tenant's default.",
          "example": "my-status-list-keychain"
        },
        "bits": {
          "description": "Bits per status value",
          "enum": [1, 2, 4, 8],
          "type": "number",
          "example": 1
        },
        "capacity": {
          "type": "number",
          "description": "Total capacity of the status list",
          "example": 10000
        },
        "usedEntries": {
          "type": "number",
          "description": "Number of entries in use",
          "example": 150
        },
        "availableEntries": {
          "type": "number",
          "description": "Number of available entries",
          "example": 9850
        },
        "uri": {
          "type": "string",
          "description": "The public URI for this status list",
          "example": "https://example.com/demo/status-management/status-list/550e8400-e29b-41d4-a716-446655440000"
        },
        "createdAt": {
          "format": "date-time",
          "type": "string",
          "description": "Creation timestamp",
          "example": "2024-01-15T10:30:00.000Z"
        },
        "expiresAt": {
          "format": "date-time",
          "type": "string",
          "nullable": true,
          "description": "JWT expiration timestamp. Null if JWT has not been generated yet.",
          "example": "2024-01-15T11:30:00.000Z"
        }
      },
      "required": [
        "id",
        "tenantId",
        "bits",
        "capacity",
        "usedEntries",
        "availableEntries",
        "uri",
        "createdAt"
      ],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/CreateStatusListDto.schema.json",
    "fileMatch": ["a://b/CreateStatusListDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/CreateStatusListDto.schema.json",
      "title": "CreateStatusListDto",
      "type": "object",
      "properties": {
        "credentialConfigurationId": {
          "type": "string",
          "description": "Credential configuration ID to bind this list exclusively to. Leave empty for a shared list.",
          "example": "org.iso.18013.5.1.mDL"
        },
        "keyChainId": {
          "type": "string",
          "description": "Key chain ID to use for signing. Leave empty to use the tenant's default StatusList key chain.",
          "example": "my-status-list-keychain"
        },
        "bits": {
          "description": "Bits per status value. More bits allow more status states. Defaults to tenant configuration.",
          "enum": [1, 2, 4, 8],
          "type": "number",
          "example": 1
        },
        "capacity": {
          "type": "number",
          "description": "Maximum number of credential status entries. Defaults to tenant configuration.",
          "minimum": 1000,
          "example": 100000
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/UpdateStatusListDto.schema.json",
    "fileMatch": ["a://b/UpdateStatusListDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/UpdateStatusListDto.schema.json",
      "title": "UpdateStatusListDto",
      "type": "object",
      "properties": {
        "credentialConfigurationId": {
          "type": "string",
          "nullable": true,
          "description": "Credential configuration ID to bind this list exclusively to. Set to null to make this a shared list.",
          "example": "org.iso.18013.5.1.mDL"
        },
        "keyChainId": {
          "type": "string",
          "nullable": true,
          "description": "Key chain ID to use for signing. Set to null to use the tenant's default StatusList key chain.",
          "example": "my-status-list-keychain"
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/AuthorizeQueries.schema.json",
    "fileMatch": ["a://b/AuthorizeQueries*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/AuthorizeQueries.schema.json",
      "title": "AuthorizeQueries",
      "type": "object",
      "properties": {
        "issuer_state": {
          "type": "string"
        },
        "response_type": {
          "type": "string"
        },
        "client_id": {
          "type": "string"
        },
        "redirect_uri": {
          "type": "string"
        },
        "resource": {
          "type": "string"
        },
        "scope": {
          "type": "string"
        },
        "code_challenge": {
          "type": "string"
        },
        "code_challenge_method": {
          "type": "string"
        },
        "dpop_jkt": {
          "type": "string"
        },
        "request_uri": {
          "type": "string"
        },
        "auth_session": {
          "type": "string"
        },
        "state": {
          "type": "string"
        },
        "authorization_details": {
          "type": "object",
          "description": "RFC 9396 authorization details. When passed via\napplication/x-www-form-urlencoded (PAR) the value is a JSON string; when\npassed inside a signed request object it can already be an array."
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/OfferRequestDto.schema.json",
    "fileMatch": ["a://b/OfferRequestDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/OfferRequestDto.schema.json",
      "title": "OfferRequestDto",
      "type": "object",
      "properties": {
        "response_type": {
          "enum": ["uri", "dc-api"],
          "type": "string",
          "examples": [
            {
              "value": "qrcode"
            }
          ],
          "description": "The type of response expected for the offer request."
        },
        "credentialClaims": {
          "type": "object",
          "description": "Credential claims configuration per credential. Keys must match credentialConfigurationIds.",
          "additionalProperties": {
            "oneOf": [
              {
                "type": "object",
                "properties": {
                  "type": {
                    "type": "string",
                    "enum": ["inline"]
                  },
                  "claims": {
                    "type": "object",
                    "additionalProperties": true
                  }
                },
                "required": ["type", "claims"],
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "type": {
                    "type": "string",
                    "enum": ["attributeProvider"]
                  },
                  "attributeProviderId": {
                    "type": "string"
                  }
                },
                "required": ["type", "attributeProviderId"],
                "additionalProperties": false
              },
              {
                "type": "object",
                "properties": {
                  "type": {
                    "type": "string",
                    "enum": ["webhook"]
                  },
                  "webhook": {
                    "type": "object",
                    "properties": {
                      "url": {
                        "type": "string"
                      },
                      "auth": {
                        "type": "object"
                      }
                    },
                    "required": ["url"],
                    "additionalProperties": false
                  }
                },
                "required": ["type", "webhook"],
                "additionalProperties": false
              }
            ]
          },
          "example": {
            "citizen": {
              "type": "inline",
              "claims": {
                "given_name": "John",
                "family_name": "Doe"
              }
            }
          }
        },
        "flow": {
          "description": "The flow type for the offer request.",
          "enum": ["authorization_code", "pre_authorized_code"],
          "type": "string"
        },
        "tx_code": {
          "type": "string",
          "description": "Transaction code for pre-authorized code flow."
        },
        "tx_code_description": {
          "type": "string",
          "description": "Description for the transaction code (e.g., \"Please enter the PIN sent to your email\")."
        },
        "credentialConfigurationIds": {
          "description": "List of credential configuration ids to be included in the offer.",
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "authorization_server": {
          "type": "string",
          "description": "Optional authorization server to be used for this issuance flow."
        },
        "webhookEndpointId": {
          "type": "string",
          "description": "ID of the webhook endpoint to notify about the status of the issuance process."
        }
      },
      "required": ["response_type", "flow", "credentialConfigurationIds"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/WebHookAuthConfigNone.schema.json",
    "fileMatch": ["a://b/WebHookAuthConfigNone*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/WebHookAuthConfigNone.schema.json",
      "title": "WebHookAuthConfigNone",
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "description": "The type of authentication used for the webhook.",
          "enum": ["none"]
        }
      },
      "required": ["type"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ApiKeyConfig.schema.json",
    "fileMatch": ["a://b/ApiKeyConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ApiKeyConfig.schema.json",
      "title": "ApiKeyConfig",
      "type": "object",
      "properties": {
        "headerName": {
          "type": "string",
          "description": "The name of the header where the API key will be sent."
        },
        "value": {
          "type": "string",
          "description": "The value of the API key to be sent in the header."
        }
      },
      "required": ["headerName", "value"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/WebHookAuthConfigHeader.schema.json",
    "fileMatch": ["a://b/WebHookAuthConfigHeader*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/WebHookAuthConfigHeader.schema.json",
      "title": "WebHookAuthConfigHeader",
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "description": "The type of authentication used for the webhook.",
          "enum": ["apiKey"]
        },
        "config": {
          "description": "Configuration for API key authentication.\nThis is required if the type is 'apiKey'.",
          "allOf": [
            {
              "$ref": "./ApiKeyConfig.schema.json"
            }
          ]
        }
      },
      "required": ["type", "config"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/WebhookConfig.schema.json",
    "fileMatch": ["a://b/WebhookConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/WebhookConfig.schema.json",
      "title": "WebhookConfig",
      "type": "object",
      "properties": {
        "auth": {
          "description": "Optional authentication configuration for the webhook.\nIf not provided, no authentication will be used.",
          "oneOf": [
            {
              "$ref": "./WebHookAuthConfigNone.schema.json"
            },
            {
              "$ref": "./WebHookAuthConfigHeader.schema.json"
            }
          ]
        },
        "includeRawTokensFor": {
          "description": "List of credential IDs to include raw tokens for (e.g., ['sca_credential'])",
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "url": {
          "type": "string",
          "description": "The URL to which the webhook will send notifications."
        }
      },
      "required": ["auth", "url"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/TransactionData.schema.json",
    "fileMatch": ["a://b/TransactionData*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/TransactionData.schema.json",
      "title": "TransactionData",
      "type": "object",
      "properties": {
        "type": {
          "type": "string"
        },
        "credential_ids": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": ["type", "credential_ids"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/Session.schema.json",
    "fileMatch": ["a://b/Session*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/Session.schema.json",
      "title": "Session",
      "type": "object",
      "properties": {
        "status": {
          "description": "Status of the session.",
          "enum": ["active", "fetched", "completed", "expired", "failed"],
          "type": "string"
        },
        "id": {
          "type": "string",
          "description": "Unique identifier for the session."
        },
        "createdAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the request was created."
        },
        "updatedAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the request was last updated."
        },
        "expiresAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the request is set to expire."
        },
        "useDcApi": {
          "type": "boolean",
          "description": "Flag indicating whether to use the DC API for the presentation request."
        },
        "tenantId": {
          "type": "string",
          "description": "Tenant ID for multi-tenancy support."
        },
        "tenant": {
          "description": "The tenant that owns this object.",
          "allOf": [
            {
              "$ref": "./TenantEntity.schema.json"
            }
          ]
        },
        "authorization_code": {
          "type": "string"
        },
        "refresh_token": {
          "type": "string",
          "description": "Refresh token for the session - used to obtain a new access token."
        },
        "refresh_token_expires_at": {
          "format": "date-time",
          "type": "string",
          "description": "Expiration timestamp for the refresh token.\nUsed to validate refresh_token grant requests."
        },
        "request_uri": {
          "type": "string",
          "description": "Request URI from the authorization request."
        },
        "auth_queries": {
          "description": "Authorization queries associated with the session.\nEncrypted at rest.",
          "allOf": [
            {
              "$ref": "./AuthorizeQueries.schema.json"
            }
          ]
        },
        "offer": {
          "description": "Credential offer object containing details about the credential offer or presentation request.\nEncrypted at rest.",
          "type": "object"
        },
        "offerUrl": {
          "type": "string",
          "description": "Offer URL for the credential offer."
        },
        "credentialPayload": {
          "description": "Credential payload containing the offer request details.\nEncrypted at rest - may contain sensitive claim data.",
          "allOf": [
            {
              "$ref": "./OfferRequestDto.schema.json"
            }
          ]
        },
        "webhookEndpointId": {
          "type": "string",
          "description": "ID of the webhook endpoint to notify about issuance status."
        },
        "notifications": {
          "description": "Notifications associated with the session.",
          "type": "array",
          "items": {
            "type": "object"
          }
        },
        "requestId": {
          "type": "string"
        },
        "requestUrl": {
          "type": "string",
          "description": "The URL of the presentation auth request."
        },
        "requestObject": {
          "type": "string",
          "description": "Signed presentation auth request."
        },
        "credentials": {
          "description": "Verified credentials from the presentation process.\nEncrypted at rest - contains personal information.",
          "type": "array",
          "items": {
            "type": "object"
          }
        },
        "vp_nonce": {
          "type": "string",
          "description": "Noncce from the Verifiable Presentation request."
        },
        "clientId": {
          "type": "string",
          "description": "Client ID used in the OID4VP authorization request."
        },
        "walletNonce": {
          "type": "string",
          "description": "Cryptographic random nonce used in wallet-facing URLs (response_uri, request_uri, state).\nPer OID4VP spec Section 13.3, this separates the wallet-facing identifier (request-id)\nfrom the frontend-facing session ID (transaction-id) to prevent session fixation."
        },
        "responseCode": {
          "type": "string",
          "description": "Cryptographic random code generated after successful VP Token processing.\nPer OID4VP spec Section 13.3, included in redirect_uri so only the legitimate\nfrontend (which receives the redirect) can confirm the session completed."
        },
        "responseUri": {
          "type": "string",
          "description": "Response URI used in the OID4VP authorization request."
        },
        "redirectUri": {
          "type": "string",
          "nullable": true,
          "description": "Redirect URI to which the user-agent should be redirected after the presentation is completed."
        },
        "parsedWebhook": {
          "description": "Where to send the claims webhook response.",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        },
        "transaction_data": {
          "description": "Transaction data to include in the OID4VP authorization request.\nCan be overridden per-request from the presentation configuration.",
          "type": "array",
          "items": {
            "$ref": "./TransactionData.schema.json"
          }
        },
        "externalIssuer": {
          "type": "string"
        },
        "externalSubject": {
          "type": "string",
          "description": "The subject (sub) from the external authorization server token.\nUsed to identify the user at the external AS."
        },
        "errorReason": {
          "type": "string",
          "description": "Error reason if the session failed.\nStores the error message when status is 'failed'."
        },
        "txCodeFailedAttempts": {
          "type": "number",
          "description": "Number of failed tx_code (transaction code) validation attempts.\nUsed to enforce brute-force protection in the pre-authorized code flow.\nReset implicitly when the session is consumed successfully."
        },
        "consumed": {
          "type": "boolean",
          "description": "Flag indicating whether the session offer has been consumed.\nPrevents replay attacks by ensuring each offer can only be used once.\nFor OID4VCI: set after successful token exchange.\nFor OID4VP: set after successful response validation."
        },
        "consumedAt": {
          "format": "date-time",
          "type": "string",
          "description": "Timestamp when the session offer was consumed.\nNull if the offer has not yet been consumed."
        }
      },
      "required": [
        "status",
        "id",
        "createdAt",
        "updatedAt",
        "useDcApi",
        "tenantId",
        "tenant",
        "notifications",
        "txCodeFailedAttempts",
        "consumed"
      ],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/PaginatedSessionResponseDto.schema.json",
    "fileMatch": ["a://b/PaginatedSessionResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/PaginatedSessionResponseDto.schema.json",
      "title": "PaginatedSessionResponseDto",
      "type": "object",
      "properties": {
        "items": {
          "description": "The sessions for the current page.",
          "type": "array",
          "items": {
            "$ref": "./Session.schema.json"
          }
        },
        "total": {
          "type": "number",
          "description": "Total number of sessions matching the query"
        },
        "page": {
          "type": "number",
          "description": "Current page number (1-based)"
        },
        "pageSize": {
          "type": "number",
          "description": "Number of items per page"
        },
        "totalPages": {
          "type": "number",
          "description": "Total number of pages"
        }
      },
      "required": ["items", "total", "page", "pageSize", "totalPages"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/SessionLogEntryResponseDto.schema.json",
    "fileMatch": ["a://b/SessionLogEntryResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/SessionLogEntryResponseDto.schema.json",
      "title": "SessionLogEntryResponseDto",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Log entry ID"
        },
        "sessionId": {
          "type": "string",
          "description": "Session ID"
        },
        "timestamp": {
          "format": "date-time",
          "type": "string",
          "description": "Timestamp of the log entry"
        },
        "level": {
          "type": "string",
          "description": "Log level",
          "enum": ["info", "warn", "error"]
        },
        "stage": {
          "type": "string",
          "description": "Flow stage"
        },
        "message": {
          "type": "string",
          "description": "Log message"
        },
        "detail": {
          "type": "object",
          "description": "Additional structured detail"
        }
      },
      "required": ["id", "sessionId", "timestamp", "level", "message"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/StatusUpdateDto.schema.json",
    "fileMatch": ["a://b/StatusUpdateDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/StatusUpdateDto.schema.json",
      "title": "StatusUpdateDto",
      "type": "object",
      "properties": {
        "sessionId": {
          "type": "string",
          "description": "The session ID of the user"
        },
        "credentialConfigurationId": {
          "type": "string",
          "description": "The ID of the credential configuration\nThis is optional, if not provided, all credentials will be revoked of the session."
        },
        "status": {
          "type": "number",
          "description": "The status of the credential\n0 = valid, 1 = revoked, 2 = suspended"
        }
      },
      "required": ["sessionId", "status"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/UpdateSessionConfigDto.schema.json",
    "fileMatch": ["a://b/UpdateSessionConfigDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/UpdateSessionConfigDto.schema.json",
      "title": "UpdateSessionConfigDto",
      "type": "object",
      "properties": {
        "ttlSeconds": {
          "type": "number",
          "nullable": true,
          "description": "Time-to-live for sessions in seconds. Set to null to use global default.",
          "minimum": 60,
          "example": 86400
        },
        "cleanupMode": {
          "description": "Cleanup mode: 'full' deletes everything, 'anonymize' keeps metadata but removes PII.",
          "enum": ["full", "anonymize"],
          "type": "string",
          "default": "full"
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ManagedUserDto.schema.json",
    "fileMatch": ["a://b/ManagedUserDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ManagedUserDto.schema.json",
      "title": "ManagedUserDto",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "example": "5a3412a4-9ccf-41aa-b79c-f7e2a8a9b0d1"
        },
        "username": {
          "type": "string",
          "example": "alice"
        },
        "email": {
          "type": "string",
          "example": "alice@example.com"
        },
        "enabled": {
          "type": "boolean",
          "example": true
        },
        "roles": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "presentation:manage",
              "presentation:request",
              "issuance:manage",
              "issuance:offer",
              "clients:manage",
              "users:manage",
              "tenants:manage",
              "registrar:manage"
            ]
          }
        },
        "tenantId": {
          "type": "string",
          "example": "tenant-a"
        },
        "temporaryPassword": {
          "type": "string",
          "example": "Ab3!zK8pQ2",
          "description": "One-time temporary password returned only on user creation."
        }
      },
      "required": ["id", "username", "enabled", "roles"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/CreateUserDto.schema.json",
    "fileMatch": ["a://b/CreateUserDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/CreateUserDto.schema.json",
      "title": "CreateUserDto",
      "type": "object",
      "properties": {
        "username": {
          "type": "string",
          "minLength": 1,
          "example": "alice"
        },
        "email": {
          "type": "string",
          "example": "alice@example.com"
        },
        "roles": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "presentation:manage",
              "presentation:request",
              "issuance:manage",
              "issuance:offer",
              "clients:manage",
              "users:manage",
              "tenants:manage",
              "registrar:manage"
            ]
          }
        },
        "temporaryPassword": {
          "type": "string",
          "example": "Ab3!zK8pQ2",
          "description": "One-time temporary password returned only on user creation."
        },
        "enabled": {
          "type": "boolean",
          "example": true
        }
      },
      "required": ["username", "roles"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/UpdateUserDto.schema.json",
    "fileMatch": ["a://b/UpdateUserDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/UpdateUserDto.schema.json",
      "title": "UpdateUserDto",
      "type": "object",
      "properties": {
        "username": {
          "type": "string",
          "minLength": 1,
          "example": "alice"
        },
        "email": {
          "type": "string",
          "example": "alice@example.com"
        },
        "roles": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "presentation:manage",
              "presentation:request",
              "issuance:manage",
              "issuance:offer",
              "clients:manage",
              "users:manage",
              "tenants:manage",
              "registrar:manage"
            ]
          }
        },
        "temporaryPassword": {
          "type": "string",
          "example": "Ab3!zK8pQ2",
          "description": "One-time temporary password returned only on user creation."
        },
        "enabled": {
          "type": "boolean",
          "example": true
        },
        "password": {
          "type": "string",
          "minLength": 8,
          "example": "S3cur3P@ssword"
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/AuthenticationMethodNone.schema.json",
    "fileMatch": ["a://b/AuthenticationMethodNone*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/AuthenticationMethodNone.schema.json",
      "title": "AuthenticationMethodNone",
      "type": "object",
      "properties": {
        "method": {
          "type": "string",
          "enum": ["none"]
        }
      },
      "required": ["method"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/AuthenticationUrlConfig.schema.json",
    "fileMatch": ["a://b/AuthenticationUrlConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/AuthenticationUrlConfig.schema.json",
      "title": "AuthenticationUrlConfig",
      "type": "object",
      "properties": {
        "url": {
          "type": "string",
          "description": "The URL used in the OID4VCI authorized code flow.\nThis URL is where users will be redirected for authentication."
        },
        "webhook": {
          "description": "Optional webhook configuration for authentication callbacks",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        }
      },
      "required": ["url"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/AuthenticationMethodAuth.schema.json",
    "fileMatch": ["a://b/AuthenticationMethodAuth*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/AuthenticationMethodAuth.schema.json",
      "title": "AuthenticationMethodAuth",
      "type": "object",
      "properties": {
        "method": {
          "type": "string",
          "enum": ["auth"]
        },
        "config": {
          "$ref": "./AuthenticationUrlConfig.schema.json"
        }
      },
      "required": ["method", "config"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/PresentationDuringIssuanceConfig.schema.json",
    "fileMatch": ["a://b/PresentationDuringIssuanceConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/PresentationDuringIssuanceConfig.schema.json",
      "title": "PresentationDuringIssuanceConfig",
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "description": "Link to the presentation configuration that is relevant for the issuance process"
        }
      },
      "required": ["type"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/AuthenticationMethodPresentation.schema.json",
    "fileMatch": ["a://b/AuthenticationMethodPresentation*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/AuthenticationMethodPresentation.schema.json",
      "title": "AuthenticationMethodPresentation",
      "type": "object",
      "properties": {
        "method": {
          "type": "string",
          "enum": ["presentationDuringIssuance"]
        },
        "config": {
          "$ref": "./PresentationDuringIssuanceConfig.schema.json"
        }
      },
      "required": ["method", "config"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/UpstreamOidcConfig.schema.json",
    "fileMatch": ["a://b/UpstreamOidcConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/UpstreamOidcConfig.schema.json",
      "title": "UpstreamOidcConfig",
      "type": "object",
      "properties": {
        "issuer": {
          "type": "string",
          "description": "The OIDC issuer URL of the upstream provider",
          "example": "https://auth.example.com/realms/myrealm",
          "format": "uri"
        },
        "clientId": {
          "type": "string",
          "description": "The client ID registered with the upstream provider",
          "example": "eudiplo-chained-as"
        },
        "clientSecret": {
          "type": "string",
          "description": "The client secret for confidential clients"
        },
        "scopes": {
          "description": "Scopes to request from the upstream provider",
          "default": ["openid", "profile"],
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": ["issuer", "clientId"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ChainedAsTokenConfig.schema.json",
    "fileMatch": ["a://b/ChainedAsTokenConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ChainedAsTokenConfig.schema.json",
      "title": "ChainedAsTokenConfig",
      "type": "object",
      "properties": {
        "lifetimeSeconds": {
          "type": "number",
          "description": "Access token lifetime in seconds",
          "minimum": 60,
          "default": 3600
        },
        "signingKeyId": {
          "type": "string",
          "description": "Key ID for token signing"
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ChainedAsConfig.schema.json",
    "fileMatch": ["a://b/ChainedAsConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ChainedAsConfig.schema.json",
      "title": "ChainedAsConfig",
      "type": "object",
      "properties": {
        "enabled": {
          "type": "boolean",
          "description": "Enable chained AS mode",
          "default": false
        },
        "upstream": {
          "description": "Upstream OIDC provider configuration",
          "allOf": [
            {
              "$ref": "./UpstreamOidcConfig.schema.json"
            }
          ]
        },
        "token": {
          "description": "Token configuration",
          "allOf": [
            {
              "$ref": "./ChainedAsTokenConfig.schema.json"
            }
          ]
        },
        "requireDPoP": {
          "type": "boolean",
          "description": "Require DPoP binding for tokens",
          "default": true
        }
      },
      "required": ["enabled"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/FederationTrustAnchorConfig.schema.json",
    "fileMatch": ["a://b/FederationTrustAnchorConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/FederationTrustAnchorConfig.schema.json",
      "title": "FederationTrustAnchorConfig",
      "type": "object",
      "properties": {
        "entityId": {
          "type": "string",
          "description": "Entity identifier (sub) of the federation trust anchor.",
          "example": "https://ta.example.org"
        },
        "entityConfigurationUri": {
          "type": "string",
          "description": "Federation endpoint URL for the trust anchor entity configuration.",
          "example": "https://ta.example.org/.well-known/openid-federation"
        }
      },
      "required": ["entityId", "entityConfigurationUri"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/FederationConfig.schema.json",
    "fileMatch": ["a://b/FederationConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/FederationConfig.schema.json",
      "title": "FederationConfig",
      "type": "object",
      "properties": {
        "role": {
          "enum": ["trust_anchor", "intermediate", "leaf"],
          "type": "string",
          "description": "Role this tenant plays in the OpenID Federation topology.",
          "default": "leaf"
        },
        "mode": {
          "enum": ["federation-only", "hybrid"],
          "type": "string",
          "description": "Trust decision strategy when both LoTE trust lists and OpenID Federation are configured.",
          "default": "hybrid"
        },
        "entityId": {
          "type": "string",
          "description": "Entity identifier of this issuer/verifier in the federation.",
          "example": "https://issuer.example.org"
        },
        "enforceSigningPolicy": {
          "type": "boolean",
          "description": "Whether federation checks are enforced for upstream metadata and signer trust decisions.",
          "default": true
        },
        "cacheTtlSeconds": {
          "type": "number",
          "description": "Cache TTL in seconds for federation entity statements and trust chain results.",
          "default": 300
        },
        "trustAnchors": {
          "description": "Configured federation trust anchors.",
          "type": "array",
          "items": {
            "$ref": "./FederationTrustAnchorConfig.schema.json"
          }
        }
      },
      "required": ["trustAnchors"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/DisplayLogo.schema.json",
    "fileMatch": ["a://b/DisplayLogo*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/DisplayLogo.schema.json",
      "title": "DisplayLogo",
      "type": "object",
      "properties": {
        "uri": {
          "type": "string"
        },
        "alt_text": {
          "type": "string"
        }
      },
      "required": ["uri"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/DisplayInfo.schema.json",
    "fileMatch": ["a://b/DisplayInfo*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/DisplayInfo.schema.json",
      "title": "DisplayInfo",
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "locale": {
          "type": "string"
        },
        "logo": {
          "$ref": "./DisplayLogo.schema.json"
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/IssuanceConfig.schema.json",
    "fileMatch": ["a://b/IssuanceConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/IssuanceConfig.schema.json",
      "title": "IssuanceConfig",
      "type": "object",
      "properties": {
        "signingKeyId": {
          "type": "string",
          "description": "Key ID for signing access tokens. If unset, the default signing key is used."
        },
        "chainedAs": {
          "nullable": true,
          "description": "Configuration for Chained Authorization Server mode.\nWhen enabled, EUDIPLO acts as an OAuth AS facade, delegating user authentication\nto an upstream OIDC provider while issuing its own tokens with issuer_state.",
          "type": "object",
          "allOf": [
            {
              "$ref": "./ChainedAsConfig.schema.json"
            }
          ]
        },
        "federation": {
          "nullable": true,
          "description": "Optional OpenID Federation configuration used for trust evaluation.\nWhen omitted, trust checks rely on existing LoTE trust-list behavior.",
          "type": "object",
          "allOf": [
            {
              "$ref": "./FederationConfig.schema.json"
            }
          ]
        },
        "refreshTokenEnabled": {
          "type": "boolean",
          "description": "Whether refresh tokens should be issued for OID4VCI token responses.",
          "default": true
        },
        "credentialResponseEncryption": {
          "type": "boolean",
          "description": "Whether `credential_response_encryption` should be advertised in the credential issuer metadata.",
          "default": false
        },
        "credentialRequestEncryption": {
          "type": "boolean",
          "description": "Whether `credential_request_encryption` should be advertised in the credential issuer metadata.",
          "default": false
        },
        "refreshTokenExpiresInSeconds": {
          "type": "number",
          "description": "Refresh token lifetime in seconds. Defaults to 2592000 (30 days).",
          "default": 2592000,
          "nullable": true
        },
        "txCodeMaxAttempts": {
          "type": "number",
          "description": "Maximum failed tx_code attempts before the pre-authorized code is invalidated. Defaults to 5.",
          "default": 5,
          "nullable": true
        },
        "tenant": {
          "description": "The tenant that owns this object.",
          "allOf": [
            {
              "$ref": "./TenantEntity.schema.json"
            }
          ]
        },
        "authServers": {
          "description": "Authentication server URL for the issuance process.",
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "batchSize": {
          "type": "number",
          "description": "Value to determine the amount of credentials that are issued in a batch.\nDefault is 1."
        },
        "dPopRequired": {
          "type": "boolean",
          "description": "Indicates whether DPoP is required for the issuance process. Default value is true."
        },
        "walletAttestationRequired": {
          "type": "boolean",
          "description": "Indicates whether wallet attestation is required for the token endpoint.\nWhen enabled, wallets must provide OAuth-Client-Attestation headers.\nDefault value is false."
        },
        "walletProviderTrustLists": {
          "description": "URLs of trust lists containing trusted wallet providers.\nThe wallet attestation's X.509 certificate will be validated against these trust lists.\nIf empty and walletAttestationRequired is true, all wallet providers are rejected.",
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "preferredAuthServer": {
          "type": "string",
          "description": "The URL of the preferred authorization server for wallet-initiated flows.\nWhen set, this AS is placed first in the `authorization_servers` array\nof the credential issuer metadata, signaling wallets to use it by default.\nMust match one of the configured auth servers, the chained AS URL, or \"built-in\"."
        },
        "display": {
          "type": "array",
          "items": {
            "$ref": "./DisplayInfo.schema.json"
          }
        },
        "createdAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the VP request was created."
        },
        "updatedAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the VP request was last updated."
        }
      },
      "required": ["tenant", "display", "createdAt", "updatedAt"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/IssuanceDto.schema.json",
    "fileMatch": ["a://b/IssuanceDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/IssuanceDto.schema.json",
      "title": "IssuanceDto",
      "type": "object",
      "properties": {
        "signingKeyId": {
          "type": "string",
          "description": "Key ID for signing access tokens. If unset, the default signing key is used."
        },
        "chainedAs": {
          "nullable": true,
          "description": "Configuration for Chained Authorization Server mode.\nWhen enabled, EUDIPLO acts as an OAuth AS facade, delegating user authentication\nto an upstream OIDC provider while issuing its own tokens with issuer_state.",
          "type": "object",
          "allOf": [
            {
              "$ref": "./ChainedAsConfig.schema.json"
            }
          ]
        },
        "federation": {
          "nullable": true,
          "description": "Optional OpenID Federation configuration used for trust evaluation.\nWhen omitted, trust checks rely on existing LoTE trust-list behavior.",
          "type": "object",
          "allOf": [
            {
              "$ref": "./FederationConfig.schema.json"
            }
          ]
        },
        "refreshTokenEnabled": {
          "type": "boolean",
          "description": "Whether refresh tokens should be issued for OID4VCI token responses.",
          "default": true
        },
        "credentialResponseEncryption": {
          "type": "boolean",
          "description": "Whether `credential_response_encryption` should be advertised in the credential issuer metadata.",
          "default": false
        },
        "credentialRequestEncryption": {
          "type": "boolean",
          "description": "Whether `credential_request_encryption` should be advertised in the credential issuer metadata.",
          "default": false
        },
        "refreshTokenExpiresInSeconds": {
          "type": "number",
          "description": "Refresh token lifetime in seconds. Defaults to 2592000 (30 days).",
          "default": 2592000,
          "nullable": true
        },
        "txCodeMaxAttempts": {
          "type": "number",
          "description": "Maximum failed tx_code attempts before the pre-authorized code is invalidated. Defaults to 5.",
          "default": 5,
          "nullable": true
        },
        "authServers": {
          "description": "Authentication server URL for the issuance process.",
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "batchSize": {
          "type": "number",
          "description": "Value to determine the amount of credentials that are issued in a batch.\nDefault is 1."
        },
        "dPopRequired": {
          "type": "boolean",
          "description": "Indicates whether DPoP is required for the issuance process. Default value is true."
        },
        "walletAttestationRequired": {
          "type": "boolean",
          "description": "Indicates whether wallet attestation is required for the token endpoint.\nWhen enabled, wallets must provide OAuth-Client-Attestation headers.\nDefault value is false."
        },
        "walletProviderTrustLists": {
          "description": "URLs of trust lists containing trusted wallet providers.\nThe wallet attestation's X.509 certificate will be validated against these trust lists.\nIf empty and walletAttestationRequired is true, all wallet providers are rejected.",
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "preferredAuthServer": {
          "type": "string",
          "description": "The URL of the preferred authorization server for wallet-initiated flows.\nWhen set, this AS is placed first in the `authorization_servers` array\nof the credential issuer metadata, signaling wallets to use it by default.\nMust match one of the configured auth servers, the chained AS URL, or \"built-in\"."
        },
        "display": {
          "type": "array",
          "items": {
            "$ref": "./DisplayInfo.schema.json"
          }
        }
      },
      "required": ["display"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ClaimsQuery.schema.json",
    "fileMatch": ["a://b/ClaimsQuery*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ClaimsQuery.schema.json",
      "title": "ClaimsQuery",
      "type": "object",
      "properties": {
        "id": {
          "type": "string"
        },
        "path": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "values": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": ["path"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/TrustedAuthorityQuery.schema.json",
    "fileMatch": ["a://b/TrustedAuthorityQuery*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/TrustedAuthorityQuery.schema.json",
      "title": "TrustedAuthorityQuery",
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": ["etsi_tl", "openid_federation"]
        },
        "values": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": ["type", "values"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/CredentialQuery.schema.json",
    "fileMatch": ["a://b/CredentialQuery*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/CredentialQuery.schema.json",
      "title": "CredentialQuery",
      "type": "object",
      "properties": {
        "id": {
          "type": "string"
        },
        "format": {
          "type": "string"
        },
        "multiple": {
          "type": "boolean"
        },
        "claims": {
          "type": "array",
          "items": {
            "$ref": "./ClaimsQuery.schema.json"
          }
        },
        "meta": {
          "type": "object"
        },
        "trusted_authorities": {
          "type": "array",
          "items": {
            "$ref": "./TrustedAuthorityQuery.schema.json"
          }
        }
      },
      "required": ["id", "format", "meta"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/CredentialSetQuery.schema.json",
    "fileMatch": ["a://b/CredentialSetQuery*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/CredentialSetQuery.schema.json",
      "title": "CredentialSetQuery",
      "type": "object",
      "properties": {
        "options": {
          "type": "array",
          "items": {
            "type": "array",
            "items": {
              "type": "string"
            }
          }
        },
        "required": {
          "type": "boolean"
        }
      },
      "required": ["options"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/PolicyCredential.schema.json",
    "fileMatch": ["a://b/PolicyCredential*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/PolicyCredential.schema.json",
      "title": "PolicyCredential",
      "type": "object",
      "properties": {
        "claims": {
          "type": "array",
          "items": {
            "$ref": "./ClaimsQuery.schema.json"
          }
        },
        "credentials": {
          "type": "array",
          "items": {
            "$ref": "./CredentialQuery.schema.json"
          }
        },
        "credential_sets": {
          "type": "array",
          "items": {
            "$ref": "./CredentialSetQuery.schema.json"
          }
        }
      },
      "required": ["credentials"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/AttestationBasedPolicy.schema.json",
    "fileMatch": ["a://b/AttestationBasedPolicy*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/AttestationBasedPolicy.schema.json",
      "title": "AttestationBasedPolicy",
      "type": "object",
      "properties": {
        "policy": {
          "type": "string",
          "enum": ["attestationBased"]
        },
        "values": {
          "type": "array",
          "items": {
            "$ref": "./PolicyCredential.schema.json"
          }
        }
      },
      "required": ["policy", "values"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/NoneTrustPolicy.schema.json",
    "fileMatch": ["a://b/NoneTrustPolicy*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/NoneTrustPolicy.schema.json",
      "title": "NoneTrustPolicy",
      "type": "object",
      "properties": {
        "policy": {
          "type": "string",
          "enum": ["none"]
        }
      },
      "required": ["policy"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/AllowListPolicy.schema.json",
    "fileMatch": ["a://b/AllowListPolicy*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/AllowListPolicy.schema.json",
      "title": "AllowListPolicy",
      "type": "object",
      "properties": {
        "policy": {
          "type": "string",
          "enum": ["allowList"]
        },
        "values": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": ["policy", "values"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/RootOfTrustPolicy.schema.json",
    "fileMatch": ["a://b/RootOfTrustPolicy*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/RootOfTrustPolicy.schema.json",
      "title": "RootOfTrustPolicy",
      "type": "object",
      "properties": {
        "policy": {
          "type": "string",
          "enum": ["rootOfTrust"]
        },
        "values": {
          "type": "string"
        }
      },
      "required": ["policy", "values"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/VCT.schema.json",
    "fileMatch": ["a://b/VCT*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/VCT.schema.json",
      "title": "VCT",
      "type": "object",
      "properties": {
        "vct": {
          "type": "string"
        },
        "name": {
          "type": "string"
        },
        "description": {
          "type": "string"
        },
        "extends": {
          "type": "string"
        },
        "extends#integrity": {
          "type": "string"
        },
        "schema_uri": {
          "type": "string"
        },
        "schema_uri#integrity": {
          "type": "string"
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/IaeActionOpenid4vpPresentation.schema.json",
    "fileMatch": ["a://b/IaeActionOpenid4vpPresentation*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/IaeActionOpenid4vpPresentation.schema.json",
      "title": "IaeActionOpenid4vpPresentation",
      "type": "object",
      "properties": {
        "type": {
          "enum": ["openid4vp_presentation"],
          "type": "string",
          "description": "Action type discriminator",
          "example": "openid4vp_presentation"
        },
        "label": {
          "type": "string",
          "description": "Optional label for this step (for display purposes)",
          "example": "Identity Verification"
        },
        "presentationConfigId": {
          "type": "string",
          "description": "ID of the presentation configuration to use for this step",
          "example": "pid-presentation-config"
        }
      },
      "required": ["type", "presentationConfigId"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/IaeActionRedirectToWeb.schema.json",
    "fileMatch": ["a://b/IaeActionRedirectToWeb*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/IaeActionRedirectToWeb.schema.json",
      "title": "IaeActionRedirectToWeb",
      "type": "object",
      "properties": {
        "type": {
          "enum": ["redirect_to_web"],
          "type": "string",
          "description": "Action type discriminator",
          "example": "redirect_to_web"
        },
        "label": {
          "type": "string",
          "description": "Optional label for this step (for display purposes)",
          "example": "Identity Verification"
        },
        "url": {
          "type": "string",
          "format": "uri",
          "description": "URL to redirect the user to for web-based interaction",
          "example": "https://example.com/verify?session={auth_session}"
        },
        "callbackUrl": {
          "type": "string",
          "format": "uri",
          "description": "URL where the external service should redirect back after completion. If not provided, the service must call back to the IAE endpoint.",
          "example": "https://issuer.example.com/{tenantId}/authorize/interactive/callback"
        },
        "description": {
          "type": "string",
          "description": "Description of what the user should do on the web page (for wallet display)",
          "example": "Please complete the identity verification form"
        }
      },
      "required": ["type", "url"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/WebhookEndpointEntity.schema.json",
    "fileMatch": ["a://b/WebhookEndpointEntity*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/WebhookEndpointEntity.schema.json",
      "title": "WebhookEndpointEntity",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Unique identifier for the webhook endpoint"
        },
        "auth": {
          "oneOf": [
            {
              "$ref": "./WebHookAuthConfigNone.schema.json"
            },
            {
              "$ref": "./WebHookAuthConfigHeader.schema.json"
            }
          ]
        },
        "tenantId": {
          "type": "string"
        },
        "tenant": {
          "$ref": "./TenantEntity.schema.json"
        },
        "name": {
          "type": "string"
        },
        "description": {
          "type": "string",
          "nullable": true
        },
        "url": {
          "type": "string"
        }
      },
      "required": ["id", "auth", "tenantId", "tenant", "name", "url"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/SchemaUriEntry.schema.json",
    "fileMatch": ["a://b/SchemaUriEntry*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/SchemaUriEntry.schema.json",
      "title": "SchemaUriEntry",
      "type": "object",
      "properties": {
        "credentialConfigId": {
          "type": "string",
          "description": "Credential config ID to resolve and upload its schema content. When set, uri can be omitted and is resolved server-side.",
          "example": "pid_de_credential_config"
        },
        "format": {
          "type": "string",
          "description": "Attestation format this schema URI applies to (e.g. dc+sd-jwt, mso_mdoc)",
          "example": "dc+sd-jwt"
        },
        "uri": {
          "type": "string",
          "description": "URI pointing to the schema document for this format"
        },
        "meta": {
          "type": "object",
          "description": "Schema-format specific metadata (for example { vct: 'urn:example:vct' } for dc+sd-jwt).",
          "additionalProperties": true
        }
      },
      "required": ["meta"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/TrustAuthorityEntry.schema.json",
    "fileMatch": ["a://b/TrustAuthorityEntry*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/TrustAuthorityEntry.schema.json",
      "title": "TrustAuthorityEntry",
      "type": "object",
      "properties": {
        "trustListId": {
          "type": "string",
          "description": "Trust list ID to resolve from the database. When set, frameworkType, value, and verificationMethod are derived automatically."
        },
        "frameworkType": {
          "enum": ["aki", "etsi_tl", "openid_federation"],
          "type": "string",
          "description": "Trust framework type (ignored when trustListId is set)"
        },
        "value": {
          "type": "string",
          "description": "URI of the trust list or trust anchor (ignored when trustListId is set)"
        },
        "isLoTE": {
          "type": "boolean",
          "description": "Whether this trust authority is a List of Trusted Entities (LoTE)"
        },
        "verificationMethod": {
          "type": "object",
          "description": "Optional verification material for external trusted authorities (for example a JWK). For internal trust-list URLs, EUDIPLO resolves verification material from the database.",
          "additionalProperties": true
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/SchemaMetaConfig.schema.json",
    "fileMatch": ["a://b/SchemaMetaConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/SchemaMetaConfig.schema.json",
      "title": "SchemaMetaConfig",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Optional override for the schema ID (attestation identifier URI). When not set, derived from vct (dc+sd-jwt) or docType (mso_mdoc).",
          "example": "https://example.com/attestations/my-credential"
        },
        "version": {
          "type": "string",
          "description": "Schema version in SemVer format",
          "example": "1.0.0"
        },
        "rulebookURI": {
          "type": "string",
          "description": "URI of the Attestation Rulebook",
          "example": "https://example.com/rulebooks/my-credential/1.0.0.md"
        },
        "attestationLoS": {
          "enum": [
            "iso_18045_high",
            "iso_18045_moderate",
            "iso_18045_enhanced-basic",
            "iso_18045_basic"
          ],
          "type": "string",
          "description": "Attestation Level of Security"
        },
        "bindingType": {
          "enum": ["claim", "key", "biometric", "none"],
          "type": "string",
          "description": "Cryptographic binding type"
        },
        "schemaURIs": {
          "description": "Schema URIs per attestation format. When omitted, the format is derived from the credential config format field.",
          "type": "array",
          "items": {
            "$ref": "./SchemaUriEntry.schema.json"
          }
        },
        "trustedAuthorities": {
          "description": "Trust authorities for this attestation schema",
          "type": "array",
          "items": {
            "$ref": "./TrustAuthorityEntry.schema.json"
          }
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/EmbeddedDisclosurePolicy.schema.json",
    "fileMatch": ["a://b/EmbeddedDisclosurePolicy*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/EmbeddedDisclosurePolicy.schema.json",
      "title": "EmbeddedDisclosurePolicy",
      "type": "object",
      "properties": {
        "policy": {
          "type": "string"
        }
      },
      "required": ["policy"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/KeyAttestationsRequired.schema.json",
    "fileMatch": ["a://b/KeyAttestationsRequired*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/KeyAttestationsRequired.schema.json",
      "title": "KeyAttestationsRequired",
      "type": "object",
      "properties": {
        "key_storage": {
          "description": "List of required key storage types (e.g., iso_18045_high, iso_18045_moderate)",
          "example": ["iso_18045_high", "iso_18045_moderate"],
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "user_authentication": {
          "description": "List of required user authentication types (e.g., iso_18045_high, iso_18045_moderate)",
          "example": ["iso_18045_high", "iso_18045_moderate"],
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/DisplayImage.schema.json",
    "fileMatch": ["a://b/DisplayImage*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/DisplayImage.schema.json",
      "title": "DisplayImage",
      "type": "object",
      "properties": {
        "uri": {
          "type": "string"
        }
      },
      "required": ["uri"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/Display.schema.json",
    "fileMatch": ["a://b/Display*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/Display.schema.json",
      "title": "Display",
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "description": {
          "type": "string"
        },
        "locale": {
          "type": "string"
        },
        "background_color": {
          "type": "string"
        },
        "text_color": {
          "type": "string"
        },
        "background_image": {
          "$ref": "./DisplayImage.schema.json"
        },
        "logo": {
          "$ref": "./DisplayImage.schema.json"
        }
      },
      "required": ["name", "description", "locale"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/IssuerMetadataCredentialConfig.schema.json",
    "fileMatch": ["a://b/IssuerMetadataCredentialConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/IssuerMetadataCredentialConfig.schema.json",
      "title": "IssuerMetadataCredentialConfig",
      "type": "object",
      "properties": {
        "keyAttestationsRequired": {
          "description": "Key attestation requirements for JWT proofs for this credential.\nWhen set, this is published in proof_types_supported.jwt.key_attestations_required\nfor this specific credential configuration.",
          "allOf": [
            {
              "$ref": "./KeyAttestationsRequired.schema.json"
            }
          ]
        },
        "format": {
          "type": "string",
          "enum": ["mso_mdoc", "dc+sd-jwt"]
        },
        "display": {
          "type": "array",
          "items": {
            "$ref": "./Display.schema.json"
          }
        },
        "scope": {
          "type": "string"
        },
        "docType": {
          "type": "string",
          "description": "Document type for mDOC credentials (e.g., \"org.iso.18013.5.1.mDL\").\nOnly applicable when format is \"mso_mdoc\"."
        }
      },
      "required": ["format", "display"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/FieldDisplayDto.schema.json",
    "fileMatch": ["a://b/FieldDisplayDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/FieldDisplayDto.schema.json",
      "title": "FieldDisplayDto",
      "type": "object",
      "properties": {
        "locale": {
          "type": "string",
          "description": "Locale code based on BCP47 (RFC 5646)",
          "example": "en-US"
        },
        "name": {
          "type": "string",
          "description": "Display name",
          "example": "Given Name"
        },
        "description": {
          "type": "string",
          "description": "Optional display description",
          "example": "Primary first name"
        }
      },
      "required": ["locale", "name"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ClaimFieldDefinitionDto.schema.json",
    "fileMatch": ["a://b/ClaimFieldDefinitionDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ClaimFieldDefinitionDto.schema.json",
      "title": "ClaimFieldDefinitionDto",
      "type": "object",
      "properties": {
        "path": {
          "type": "array",
          "description": "Path to claim value",
          "example": ["address", "locality"],
          "items": {
            "oneOf": [
              {
                "type": "string"
              },
              {
                "type": "number"
              },
              {
                "type": "null"
              }
            ]
          }
        },
        "type": {
          "enum": ["string", "number", "integer", "boolean", "object", "array", "date"],
          "type": "string",
          "description": "Claim value type"
        },
        "defaultValue": {
          "description": "Default value",
          "oneOf": [
            {
              "type": "string"
            },
            {
              "type": "number"
            },
            {
              "type": "boolean"
            },
            {
              "type": "object",
              "additionalProperties": true
            },
            {
              "type": "array",
              "items": {}
            },
            {
              "type": "null"
            }
          ]
        },
        "mandatory": {
          "type": "boolean",
          "description": "Whether claim is mandatory"
        },
        "disclosable": {
          "type": "boolean",
          "description": "Whether claim is disclosable in SD-JWT"
        },
        "namespace": {
          "type": "string",
          "description": "Namespace for mDOC field",
          "example": "eu.europa.ec.eudi.pid.1"
        },
        "display": {
          "type": "array",
          "items": {
            "$ref": "./FieldDisplayDto.schema.json"
          }
        },
        "constraints": {
          "type": "object",
          "description": "Additional JSON schema constraints for this field"
        }
      },
      "required": ["path", "type"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/AttributeProviderEntity.schema.json",
    "fileMatch": ["a://b/AttributeProviderEntity*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/AttributeProviderEntity.schema.json",
      "title": "AttributeProviderEntity",
      "type": "object",
      "properties": {
        "auth": {
          "oneOf": [
            {
              "$ref": "./WebHookAuthConfigNone.schema.json"
            },
            {
              "$ref": "./WebHookAuthConfigHeader.schema.json"
            }
          ]
        },
        "id": {
          "type": "string"
        },
        "tenantId": {
          "type": "string"
        },
        "tenant": {
          "$ref": "./TenantEntity.schema.json"
        },
        "name": {
          "type": "string"
        },
        "description": {
          "type": "string",
          "nullable": true
        },
        "url": {
          "type": "string"
        }
      },
      "required": ["auth", "id", "tenantId", "tenant", "name", "url"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/KeyChainEntity.schema.json",
    "fileMatch": ["a://b/KeyChainEntity*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/KeyChainEntity.schema.json",
      "title": "KeyChainEntity",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Unique identifier for the key chain.\nThis is the ID referenced by other entities (e.g., issuance config's signingKeyId)."
        },
        "tenantId": {
          "type": "string",
          "description": "Tenant ID for the key chain."
        },
        "tenant": {
          "description": "The tenant that owns this key chain.",
          "allOf": [
            {
              "$ref": "./TenantEntity.schema.json"
            }
          ]
        },
        "description": {
          "type": "string",
          "description": "Human-readable description of the key chain."
        },
        "usageType": {
          "type": "string",
          "description": "The purpose/role of this key chain in the system.",
          "enum": ["access", "attestation", "trustList", "statusList", "encrypt"]
        },
        "usage": {
          "type": "string",
          "description": "The usage type of the keys (sign or encrypt).",
          "enum": ["sign", "encrypt"]
        },
        "kmsProvider": {
          "type": "string",
          "description": "The KMS provider used for this key chain.\nReferences a configured KMS provider name."
        },
        "externalKeyId": {
          "type": "string",
          "description": "External key identifier for cloud KMS providers.\nThis field stores the provider-specific key reference for the active signing key."
        },
        "rootJwk": {
          "type": "object"
        },
        "rootCertificate": {
          "type": "string",
          "description": "Root CA certificate in PEM format.\nSelf-signed certificate for the root CA key."
        },
        "activeJwk": {
          "type": "object"
        },
        "activeCertificate": {
          "type": "string",
          "description": "Certificate for the active signing key in PEM format.\nEither CA-signed (if rootKey exists) or self-signed."
        },
        "rotationEnabled": {
          "type": "boolean"
        },
        "rotationIntervalDays": {
          "type": "number",
          "description": "Rotation interval in days. Key material will be rotated after this many days."
        },
        "certValidityDays": {
          "type": "number",
          "description": "Certificate validity in days when generating new certificates."
        },
        "lastRotatedAt": {
          "format": "date-time",
          "type": "string",
          "description": "Timestamp of when the key was last rotated."
        },
        "previousJwk": {
          "type": "object"
        },
        "previousCertificate": {
          "type": "string",
          "description": "Certificate for the previous signing key in PEM format."
        },
        "previousKeyExpiry": {
          "format": "date-time",
          "type": "string",
          "description": "Expiry date for the previous key.\nAfter this date, the previous key should be deleted."
        },
        "createdAt": {
          "format": "date-time",
          "type": "string"
        },
        "updatedAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the key chain was last updated."
        }
      },
      "required": [
        "id",
        "tenantId",
        "tenant",
        "usageType",
        "usage",
        "kmsProvider",
        "activeJwk",
        "activeCertificate",
        "rotationEnabled",
        "createdAt",
        "updatedAt"
      ],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/CredentialConfig.schema.json",
    "fileMatch": ["a://b/CredentialConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/CredentialConfig.schema.json",
      "title": "CredentialConfig",
      "type": "object",
      "properties": {
        "vct": {
          "description": "VCT as a URI string (e.g., urn:eudi:pid:de:1) or as an object for EUDIPLO-hosted VCT",
          "anyOf": [
            {
              "type": "string",
              "description": "VCT URI string"
            },
            {
              "$ref": "./VCT.schema.json"
            },
            {
              "type": "null"
            }
          ]
        },
        "iaeActions": {
          "type": "array",
          "nullable": true,
          "description": "List of IAE actions to execute before credential issuance",
          "example": "",
          "items": {
            "oneOf": [
              {
                "$ref": "./IaeActionOpenid4vpPresentation.schema.json"
              },
              {
                "$ref": "./IaeActionRedirectToWeb.schema.json"
              }
            ]
          }
        },
        "schemaMeta": {
          "nullable": true,
          "description": "TS11 schema metadata configuration for EUDI Catalogue of Attestations.\n\nWhen present, EUDIPLO can generate a SchemaMeta object per the TS11 spec\nusing the GET /issuer/credentials/:id/schema-metadata endpoint.\n\n The underlying TS11 specification is not yet finalized.",
          "type": "object",
          "allOf": [
            {
              "$ref": "./SchemaMetaConfig.schema.json"
            }
          ]
        },
        "embeddedDisclosurePolicy": {
          "nullable": true,
          "description": "Embedded disclosure policy (discriminated union by `policy`).\nThe discriminator makes class-transformer instantiate the right subclass,\nand then class-validator runs that subclass’s rules.",
          "oneOf": [
            {
              "$ref": "./AttestationBasedPolicy.schema.json"
            },
            {
              "$ref": "./NoneTrustPolicy.schema.json"
            },
            {
              "$ref": "./AllowListPolicy.schema.json"
            },
            {
              "$ref": "./RootOfTrustPolicy.schema.json"
            }
          ],
          "allOf": [
            {
              "$ref": "./EmbeddedDisclosurePolicy.schema.json"
            }
          ]
        },
        "id": {
          "type": "string"
        },
        "description": {
          "type": "string",
          "nullable": true
        },
        "tenant": {
          "description": "The tenant that owns this object.",
          "allOf": [
            {
              "$ref": "./TenantEntity.schema.json"
            }
          ]
        },
        "config": {
          "$ref": "./IssuerMetadataCredentialConfig.schema.json"
        },
        "configVersion": {
          "type": "number"
        },
        "fields": {
          "type": "array",
          "items": {
            "$ref": "./ClaimFieldDefinitionDto.schema.json"
          }
        },
        "attributeProviderId": {
          "type": "string",
          "nullable": true,
          "description": "Reference to the attribute provider used for fetching claims.\nOptional: if set, claims will be fetched from this provider during issuance."
        },
        "attributeProvider": {
          "$ref": "./AttributeProviderEntity.schema.json"
        },
        "webhookEndpointId": {
          "type": "string",
          "nullable": true,
          "description": "Reference to the webhook endpoint used for notifications.\nOptional: if set, notifications will be sent to this endpoint."
        },
        "webhookEndpoint": {
          "$ref": "./WebhookEndpointEntity.schema.json"
        },
        "keyBinding": {
          "type": "boolean"
        },
        "keyChainId": {
          "type": "string",
          "description": "Reference to the key chain used for signing.\nOptional: if not specified, the default attestation key chain will be used."
        },
        "keyChain": {
          "$ref": "./KeyChainEntity.schema.json"
        },
        "statusManagement": {
          "type": "boolean"
        },
        "sdJwtTrustFormat": {
          "nullable": true,
          "description": "For SD-JWT credentials: determines whether to include certificate chain (x5c)\nor use federation-based trust (iss claim).\nDefault: \"x5c\" (federation must be explicitly selected)",
          "enum": ["x5c", "federation"],
          "type": "string"
        },
        "lifeTime": {
          "type": "number"
        }
      },
      "required": ["id", "tenant", "config", "configVersion", "fields"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/CredentialConfigCreate.schema.json",
    "fileMatch": ["a://b/CredentialConfigCreate*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/CredentialConfigCreate.schema.json",
      "title": "CredentialConfigCreate",
      "type": "object",
      "properties": {
        "vct": {
          "description": "VCT as a URI string (e.g., urn:eudi:pid:de:1) or as an object for EUDIPLO-hosted VCT",
          "anyOf": [
            {
              "type": "string",
              "description": "VCT URI string"
            },
            {
              "$ref": "./VCT.schema.json"
            },
            {
              "type": "null"
            }
          ]
        },
        "iaeActions": {
          "type": "array",
          "nullable": true,
          "description": "List of IAE actions to execute before credential issuance",
          "example": "",
          "items": {
            "oneOf": [
              {
                "$ref": "./IaeActionOpenid4vpPresentation.schema.json"
              },
              {
                "$ref": "./IaeActionRedirectToWeb.schema.json"
              }
            ]
          }
        },
        "schemaMeta": {
          "nullable": true,
          "description": "TS11 schema metadata configuration for EUDI Catalogue of Attestations.\n\nWhen present, EUDIPLO can generate a SchemaMeta object per the TS11 spec\nusing the GET /issuer/credentials/:id/schema-metadata endpoint.\n\n The underlying TS11 specification is not yet finalized.",
          "type": "object",
          "allOf": [
            {
              "$ref": "./SchemaMetaConfig.schema.json"
            }
          ]
        },
        "embeddedDisclosurePolicy": {
          "nullable": true,
          "description": "Embedded disclosure policy (discriminated union by `policy`).\nThe discriminator makes class-transformer instantiate the right subclass,\nand then class-validator runs that subclass’s rules.",
          "oneOf": [
            {
              "$ref": "./AttestationBasedPolicy.schema.json"
            },
            {
              "$ref": "./NoneTrustPolicy.schema.json"
            },
            {
              "$ref": "./AllowListPolicy.schema.json"
            },
            {
              "$ref": "./RootOfTrustPolicy.schema.json"
            }
          ],
          "allOf": [
            {
              "$ref": "./EmbeddedDisclosurePolicy.schema.json"
            }
          ]
        },
        "id": {
          "type": "string"
        },
        "description": {
          "type": "string",
          "nullable": true
        },
        "config": {
          "$ref": "./IssuerMetadataCredentialConfig.schema.json"
        },
        "configVersion": {
          "type": "number"
        },
        "fields": {
          "type": "array",
          "items": {
            "$ref": "./ClaimFieldDefinitionDto.schema.json"
          }
        },
        "attributeProviderId": {
          "type": "string",
          "nullable": true,
          "description": "Reference to the attribute provider used for fetching claims.\nOptional: if set, claims will be fetched from this provider during issuance."
        },
        "webhookEndpointId": {
          "type": "string",
          "nullable": true,
          "description": "Reference to the webhook endpoint used for notifications.\nOptional: if set, notifications will be sent to this endpoint."
        },
        "keyBinding": {
          "type": "boolean"
        },
        "keyChainId": {
          "type": "string",
          "description": "Reference to the key chain used for signing.\nOptional: if not specified, the default attestation key chain will be used."
        },
        "statusManagement": {
          "type": "boolean"
        },
        "sdJwtTrustFormat": {
          "nullable": true,
          "description": "For SD-JWT credentials: determines whether to include certificate chain (x5c)\nor use federation-based trust (iss claim).\nDefault: \"x5c\" (federation must be explicitly selected)",
          "enum": ["x5c", "federation"],
          "type": "string"
        },
        "lifeTime": {
          "type": "number"
        }
      },
      "required": ["id", "config", "configVersion", "fields"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/CredentialConfigUpdate.schema.json",
    "fileMatch": ["a://b/CredentialConfigUpdate*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/CredentialConfigUpdate.schema.json",
      "title": "CredentialConfigUpdate",
      "type": "object",
      "properties": {
        "vct": {
          "description": "VCT as a URI string (e.g., urn:eudi:pid:de:1) or as an object for EUDIPLO-hosted VCT",
          "anyOf": [
            {
              "type": "string",
              "description": "VCT URI string"
            },
            {
              "$ref": "./VCT.schema.json"
            },
            {
              "type": "null"
            }
          ]
        },
        "iaeActions": {
          "type": "array",
          "nullable": true,
          "description": "List of IAE actions to execute before credential issuance",
          "example": "",
          "items": {
            "oneOf": [
              {
                "$ref": "./IaeActionOpenid4vpPresentation.schema.json"
              },
              {
                "$ref": "./IaeActionRedirectToWeb.schema.json"
              }
            ]
          }
        },
        "schemaMeta": {
          "nullable": true,
          "description": "TS11 schema metadata configuration for EUDI Catalogue of Attestations.\n\nWhen present, EUDIPLO can generate a SchemaMeta object per the TS11 spec\nusing the GET /issuer/credentials/:id/schema-metadata endpoint.\n\n The underlying TS11 specification is not yet finalized.",
          "type": "object",
          "allOf": [
            {
              "$ref": "./SchemaMetaConfig.schema.json"
            }
          ]
        },
        "embeddedDisclosurePolicy": {
          "nullable": true,
          "description": "Embedded disclosure policy (discriminated union by `policy`).\nThe discriminator makes class-transformer instantiate the right subclass,\nand then class-validator runs that subclass’s rules.",
          "oneOf": [
            {
              "$ref": "./AttestationBasedPolicy.schema.json"
            },
            {
              "$ref": "./NoneTrustPolicy.schema.json"
            },
            {
              "$ref": "./AllowListPolicy.schema.json"
            },
            {
              "$ref": "./RootOfTrustPolicy.schema.json"
            }
          ],
          "allOf": [
            {
              "$ref": "./EmbeddedDisclosurePolicy.schema.json"
            }
          ]
        },
        "id": {
          "type": "string"
        },
        "description": {
          "type": "string",
          "nullable": true
        },
        "config": {
          "$ref": "./IssuerMetadataCredentialConfig.schema.json"
        },
        "configVersion": {
          "type": "number"
        },
        "fields": {
          "type": "array",
          "items": {
            "$ref": "./ClaimFieldDefinitionDto.schema.json"
          }
        },
        "attributeProviderId": {
          "type": "string",
          "nullable": true,
          "description": "Reference to the attribute provider used for fetching claims.\nOptional: if set, claims will be fetched from this provider during issuance."
        },
        "webhookEndpointId": {
          "type": "string",
          "nullable": true,
          "description": "Reference to the webhook endpoint used for notifications.\nOptional: if set, notifications will be sent to this endpoint."
        },
        "keyBinding": {
          "type": "boolean"
        },
        "keyChainId": {
          "type": "string",
          "description": "Reference to the key chain used for signing.\nOptional: if not specified, the default attestation key chain will be used."
        },
        "statusManagement": {
          "type": "boolean"
        },
        "sdJwtTrustFormat": {
          "nullable": true,
          "description": "For SD-JWT credentials: determines whether to include certificate chain (x5c)\nor use federation-based trust (iss claim).\nDefault: \"x5c\" (federation must be explicitly selected)",
          "enum": ["x5c", "federation"],
          "type": "string"
        },
        "lifeTime": {
          "type": "number"
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/SignSchemaMetaConfigDto.schema.json",
    "fileMatch": ["a://b/SignSchemaMetaConfigDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/SignSchemaMetaConfigDto.schema.json",
      "title": "SignSchemaMetaConfigDto",
      "type": "object",
      "properties": {
        "config": {
          "description": "The schema metadata configuration to sign and submit",
          "allOf": [
            {
              "$ref": "./SchemaMetaConfig.schema.json"
            }
          ]
        },
        "keyChainId": {
          "type": "string",
          "description": "ID of the key chain to use for signing. Defaults to the tenant's default key chain."
        },
        "credentialConfigId": {
          "type": "string",
          "description": "ID of the credential config to link back after submission. When provided, schemaMeta.id on the credential config is updated with the reserved attestation ID."
        }
      },
      "required": ["config"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/SignVersionSchemaMetaConfigDto.schema.json",
    "fileMatch": ["a://b/SignVersionSchemaMetaConfigDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/SignVersionSchemaMetaConfigDto.schema.json",
      "title": "SignVersionSchemaMetaConfigDto",
      "type": "object",
      "properties": {
        "config": {
          "description": "The schema metadata configuration to sign and submit as a new version. Must include the existing id.",
          "allOf": [
            {
              "$ref": "./SchemaMetaConfig.schema.json"
            }
          ]
        },
        "keyChainId": {
          "type": "string",
          "description": "ID of the key chain to use for signing. Defaults to the tenant's default key chain."
        }
      },
      "required": ["config"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/VocabularyEntryDto.schema.json",
    "fileMatch": ["a://b/VocabularyEntryDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/VocabularyEntryDto.schema.json",
      "title": "VocabularyEntryDto",
      "type": "object",
      "properties": {
        "code": {
          "type": "string",
          "description": "Stable machine-readable value to submit in schema metadata category/tags fields."
        },
        "label": {
          "type": "string",
          "description": "Display label for UI rendering."
        },
        "status": {
          "enum": ["active", "deprecated"],
          "type": "string",
          "description": "Vocabulary lifecycle status."
        },
        "replacedBy": {
          "type": "string",
          "description": "Replacement code when status is deprecated."
        }
      },
      "required": ["code", "label", "status"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/SchemaMetadataVocabulariesDto.schema.json",
    "fileMatch": ["a://b/SchemaMetadataVocabulariesDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/SchemaMetadataVocabulariesDto.schema.json",
      "title": "SchemaMetadataVocabulariesDto",
      "type": "object",
      "properties": {
        "version": {
          "type": "string",
          "description": "Vocabulary publication version for cache invalidation."
        },
        "categories": {
          "description": "Allowed category values that can be used when updating schema metadata category.",
          "type": "array",
          "items": {
            "$ref": "./VocabularyEntryDto.schema.json"
          }
        },
        "tags": {
          "description": "Allowed tag values that can be used when updating schema metadata tags.",
          "type": "array",
          "items": {
            "$ref": "./VocabularyEntryDto.schema.json"
          }
        }
      },
      "required": ["version", "categories", "tags"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/MetadataSchemaDto.schema.json",
    "fileMatch": ["a://b/MetadataSchemaDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/MetadataSchemaDto.schema.json",
      "title": "MetadataSchemaDto",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Unique identifier for this schema entry"
        },
        "formatIdentifier": {
          "enum": ["dc+sd-jwt", "mso_mdoc"],
          "type": "string",
          "description": "The credential format identifier"
        },
        "uri": {
          "type": "string",
          "description": "URI to the schema definition"
        },
        "schemaContent": {
          "type": "object",
          "description": "Inline schema content (JSON Schema)",
          "additionalProperties": true
        },
        "integrity": {
          "type": "string",
          "description": "Subresource Integrity hash for the schema"
        }
      },
      "required": ["id", "formatIdentifier"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/TrustAuthorityDto.schema.json",
    "fileMatch": ["a://b/TrustAuthorityDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/TrustAuthorityDto.schema.json",
      "title": "TrustAuthorityDto",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Unique identifier for this trust authority entry"
        },
        "frameworkType": {
          "type": "string",
          "description": "Type of trust framework",
          "enum": ["etsi_tl"]
        },
        "value": {
          "type": "string",
          "description": "URI or identifier for the trust list / authority"
        },
        "verificationMethod": {
          "type": "object",
          "description": "Verification method for the trust list signature (e.g., JWK)",
          "additionalProperties": true
        }
      },
      "required": ["id", "frameworkType", "value"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/AccessCertificateRefDto.schema.json",
    "fileMatch": ["a://b/AccessCertificateRefDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/AccessCertificateRefDto.schema.json",
      "title": "AccessCertificateRefDto",
      "type": "object",
      "properties": {
        "id": {
          "type": "string"
        },
        "relyingPartyId": {
          "type": "string"
        },
        "certificate": {
          "type": "string"
        },
        "revoked": {
          "type": "string"
        },
        "createdAt": {
          "type": "string"
        }
      },
      "required": ["id", "relyingPartyId", "certificate", "revoked", "createdAt"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/SchemaMetadataResponseDto.schema.json",
    "fileMatch": ["a://b/SchemaMetadataResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/SchemaMetadataResponseDto.schema.json",
      "title": "SchemaMetadataResponseDto",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "The unique, server-assigned identifier (UUID) for the schema metadata"
        },
        "version": {
          "type": "string",
          "description": "Version of this schema metadata (SemVer)"
        },
        "rulebookURI": {
          "type": "string",
          "description": "URI of the human-readable Rulebook document"
        },
        "rulebookIntegrity": {
          "type": "string",
          "description": "Subresource Integrity hash for the rulebook URI"
        },
        "attestationLoS": {
          "enum": [
            "iso_18045_high",
            "iso_18045_moderate",
            "iso_18045_enhanced-basic",
            "iso_18045_basic"
          ],
          "type": "string",
          "description": "Level of security (LoS) of this attestation"
        },
        "bindingType": {
          "enum": ["claim", "key", "biometric", "none"],
          "type": "string",
          "description": "Required binding type between attestation and holder"
        },
        "supportedFormats": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": ["dc+sd-jwt", "mso_mdoc"]
          },
          "description": "Credential formats in which this attestation is available"
        },
        "schemaURIs": {
          "description": "Format-specific schema URIs for this schema metadata",
          "type": "array",
          "items": {
            "$ref": "./MetadataSchemaDto.schema.json"
          }
        },
        "trustedAuthorities": {
          "description": "Trust frameworks / trust anchors applicable to this schema metadata",
          "type": "array",
          "items": {
            "$ref": "./TrustAuthorityDto.schema.json"
          }
        },
        "category": {
          "enum": ["identity", "health", "finance", "education", "mobility", "employment", "other"],
          "type": "string",
          "description": "Domain category for filtering"
        },
        "tags": {
          "description": "Free-form tags for filtering and search",
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "signedJwt": {
          "type": "string",
          "description": "The original signed JWT"
        },
        "issuer": {
          "type": "string",
          "description": "Issuer from the JWT (`iss` claim)"
        },
        "signerCertificateSerial": {
          "type": "string",
          "description": "Serial number of the access certificate that signed this schema metadata"
        },
        "signerCertificate": {
          "description": "The access certificate used to sign this schema metadata",
          "allOf": [
            {
              "$ref": "./AccessCertificateRefDto.schema.json"
            }
          ]
        },
        "issuedAt": {
          "type": "string",
          "description": "Timestamp when the JWT was issued (from the `iat` claim)"
        },
        "createdAt": {
          "type": "string",
          "description": "Server creation timestamp"
        },
        "updatedAt": {
          "type": "string",
          "description": "Last update timestamp"
        },
        "deprecated": {
          "type": "boolean",
          "description": "Whether this version is deprecated"
        },
        "deprecationMessage": {
          "type": "string",
          "description": "Deprecation message shown to consumers"
        },
        "supersededByVersion": {
          "type": "string",
          "description": "The version that supersedes this one"
        }
      },
      "required": [
        "id",
        "version",
        "attestationLoS",
        "bindingType",
        "supportedFormats",
        "schemaURIs",
        "trustedAuthorities",
        "signedJwt",
        "issuer",
        "signerCertificateSerial",
        "issuedAt",
        "createdAt",
        "updatedAt"
      ],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/UpdateSchemaMetadataDto.schema.json",
    "fileMatch": ["a://b/UpdateSchemaMetadataDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/UpdateSchemaMetadataDto.schema.json",
      "title": "UpdateSchemaMetadataDto",
      "type": "object",
      "properties": {
        "category": {
          "enum": ["identity", "health", "finance", "education", "mobility", "employment", "other"],
          "type": "string",
          "description": "Domain category for filtering"
        },
        "tags": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "pid",
              "eudi",
              "kyc",
              "aml",
              "age-verification",
              "residency",
              "membership",
              "education",
              "employment",
              "mobility"
            ]
          },
          "description": "Predefined tags for filtering and search"
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/DeprecateSchemaMetadataDto.schema.json",
    "fileMatch": ["a://b/DeprecateSchemaMetadataDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/DeprecateSchemaMetadataDto.schema.json",
      "title": "DeprecateSchemaMetadataDto",
      "type": "object",
      "properties": {
        "deprecated": {
          "type": "boolean",
          "description": "Whether to mark this version as deprecated"
        },
        "message": {
          "type": "string",
          "description": "Deprecation message shown to consumers"
        },
        "supersededByVersion": {
          "type": "string",
          "description": "The version that supersedes this one"
        }
      },
      "required": ["deprecated"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/CreateAttributeProviderDto.schema.json",
    "fileMatch": ["a://b/CreateAttributeProviderDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/CreateAttributeProviderDto.schema.json",
      "title": "CreateAttributeProviderDto",
      "type": "object",
      "properties": {
        "auth": {
          "oneOf": [
            {
              "$ref": "./WebHookAuthConfigNone.schema.json"
            },
            {
              "$ref": "./WebHookAuthConfigHeader.schema.json"
            }
          ]
        },
        "id": {
          "type": "string"
        },
        "name": {
          "type": "string"
        },
        "description": {
          "type": "string",
          "nullable": true
        },
        "url": {
          "type": "string"
        }
      },
      "required": ["auth", "id", "name", "url"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/UpdateAttributeProviderDto.schema.json",
    "fileMatch": ["a://b/UpdateAttributeProviderDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/UpdateAttributeProviderDto.schema.json",
      "title": "UpdateAttributeProviderDto",
      "type": "object",
      "properties": {
        "auth": {
          "oneOf": [
            {
              "$ref": "./WebHookAuthConfigNone.schema.json"
            },
            {
              "$ref": "./WebHookAuthConfigHeader.schema.json"
            }
          ]
        },
        "id": {
          "type": "string"
        },
        "name": {
          "type": "string"
        },
        "description": {
          "type": "string",
          "nullable": true
        },
        "url": {
          "type": "string"
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/CreateWebhookEndpointDto.schema.json",
    "fileMatch": ["a://b/CreateWebhookEndpointDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/CreateWebhookEndpointDto.schema.json",
      "title": "CreateWebhookEndpointDto",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Unique identifier for the webhook endpoint"
        },
        "auth": {
          "oneOf": [
            {
              "$ref": "./WebHookAuthConfigNone.schema.json"
            },
            {
              "$ref": "./WebHookAuthConfigHeader.schema.json"
            }
          ]
        },
        "name": {
          "type": "string"
        },
        "description": {
          "type": "string",
          "nullable": true
        },
        "url": {
          "type": "string"
        }
      },
      "required": ["id", "auth", "name", "url"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/UpdateWebhookEndpointDto.schema.json",
    "fileMatch": ["a://b/UpdateWebhookEndpointDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/UpdateWebhookEndpointDto.schema.json",
      "title": "UpdateWebhookEndpointDto",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Unique identifier for the webhook endpoint"
        },
        "auth": {
          "oneOf": [
            {
              "$ref": "./WebHookAuthConfigNone.schema.json"
            },
            {
              "$ref": "./WebHookAuthConfigHeader.schema.json"
            }
          ]
        },
        "name": {
          "type": "string"
        },
        "description": {
          "type": "string",
          "nullable": true
        },
        "url": {
          "type": "string"
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/TrustListEntityInfo.schema.json",
    "fileMatch": ["a://b/TrustListEntityInfo*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/TrustListEntityInfo.schema.json",
      "title": "TrustListEntityInfo",
      "type": "object",
      "properties": {
        "name": {
          "type": "string"
        },
        "lang": {
          "type": "string"
        },
        "uri": {
          "type": "string"
        },
        "country": {
          "type": "string"
        },
        "locality": {
          "type": "string"
        },
        "postalCode": {
          "type": "string"
        },
        "streetAddress": {
          "type": "string"
        },
        "contactUri": {
          "type": "string"
        }
      },
      "required": ["name"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/InternalTrustListEntity.schema.json",
    "fileMatch": ["a://b/InternalTrustListEntity*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/InternalTrustListEntity.schema.json",
      "title": "InternalTrustListEntity",
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": ["internal"]
        },
        "issuerKeyChainId": {
          "type": "string"
        },
        "revocationKeyChainId": {
          "type": "string"
        },
        "info": {
          "$ref": "./TrustListEntityInfo.schema.json"
        }
      },
      "required": ["type", "issuerKeyChainId", "revocationKeyChainId", "info"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ExternalTrustListEntity.schema.json",
    "fileMatch": ["a://b/ExternalTrustListEntity*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ExternalTrustListEntity.schema.json",
      "title": "ExternalTrustListEntity",
      "type": "object",
      "properties": {
        "type": {
          "type": "string",
          "enum": ["external"]
        },
        "issuerCertPem": {
          "type": "string"
        },
        "revocationCertPem": {
          "type": "string"
        },
        "info": {
          "$ref": "./TrustListEntityInfo.schema.json"
        }
      },
      "required": ["type", "issuerCertPem", "revocationCertPem", "info"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/TrustListCreateDto.schema.json",
    "fileMatch": ["a://b/TrustListCreateDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/TrustListCreateDto.schema.json",
      "title": "TrustListCreateDto",
      "type": "object",
      "properties": {
        "description": {
          "type": "string"
        },
        "data": {
          "type": "object",
          "description": "The full trust list JSON (generated LoTE structure)"
        },
        "entities": {
          "type": "array",
          "items": {
            "oneOf": [
              {
                "$ref": "./InternalTrustListEntity.schema.json"
              },
              {
                "$ref": "./ExternalTrustListEntity.schema.json"
              }
            ],
            "discriminator": {
              "propertyName": "type",
              "mapping": {
                "internal": "#/components/schemas/InternalTrustListEntity",
                "external": "#/components/schemas/ExternalTrustListEntity"
              }
            }
          }
        },
        "id": {
          "type": "string"
        },
        "keyChainId": {
          "type": "string"
        }
      },
      "required": ["entities"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/TrustList.schema.json",
    "fileMatch": ["a://b/TrustList*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/TrustList.schema.json",
      "title": "TrustList",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Unique identifier for the trust list"
        },
        "description": {
          "type": "string"
        },
        "tenantId": {
          "type": "string",
          "description": "The tenant ID for which the VP request is made."
        },
        "tenant": {
          "description": "The tenant that owns this object.",
          "allOf": [
            {
              "$ref": "./TenantEntity.schema.json"
            }
          ]
        },
        "keyChainId": {
          "type": "string"
        },
        "keyChain": {
          "$ref": "./KeyChainEntity.schema.json"
        },
        "data": {
          "type": "object",
          "description": "The full trust list JSON (generated LoTE structure)"
        },
        "entityConfig": {
          "description": "The original entity configuration used to create this trust list.\nStored for round-tripping when editing.",
          "type": "array",
          "items": {
            "type": "object"
          }
        },
        "sequenceNumber": {
          "type": "number",
          "description": "The sequence number for versioning (incremented on updates)"
        },
        "jwt": {
          "type": "string",
          "description": "The signed JWT representation of this trust list"
        },
        "createdAt": {
          "format": "date-time",
          "type": "string"
        },
        "updatedAt": {
          "format": "date-time",
          "type": "string"
        }
      },
      "required": [
        "id",
        "tenantId",
        "tenant",
        "keyChainId",
        "keyChain",
        "sequenceNumber",
        "jwt",
        "createdAt",
        "updatedAt"
      ],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/TrustListVersion.schema.json",
    "fileMatch": ["a://b/TrustListVersion*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/TrustListVersion.schema.json",
      "title": "TrustListVersion",
      "type": "object",
      "properties": {
        "id": {
          "type": "string"
        },
        "trustListId": {
          "type": "string"
        },
        "trustList": {
          "$ref": "./TrustList.schema.json"
        },
        "tenantId": {
          "type": "string"
        },
        "sequenceNumber": {
          "type": "number",
          "description": "The sequence number at the time this version was created"
        },
        "data": {
          "type": "object",
          "description": "The full trust list JSON at this version"
        },
        "entityConfig": {
          "type": "object",
          "description": "The entity configuration at this version"
        },
        "jwt": {
          "type": "string",
          "description": "The signed JWT at this version"
        },
        "createdAt": {
          "format": "date-time",
          "type": "string"
        }
      },
      "required": [
        "id",
        "trustListId",
        "trustList",
        "tenantId",
        "sequenceNumber",
        "data",
        "jwt",
        "createdAt"
      ],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/DCQL.schema.json",
    "fileMatch": ["a://b/DCQL*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/DCQL.schema.json",
      "title": "DCQL",
      "type": "object",
      "properties": {
        "credentials": {
          "type": "array",
          "items": {
            "$ref": "./CredentialQuery.schema.json"
          }
        },
        "credential_sets": {
          "type": "array",
          "items": {
            "$ref": "./CredentialSetQuery.schema.json"
          }
        }
      },
      "required": ["credentials"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/RegistrationCertificatePurpose.schema.json",
    "fileMatch": ["a://b/RegistrationCertificatePurpose*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/RegistrationCertificatePurpose.schema.json",
      "title": "RegistrationCertificatePurpose",
      "type": "object",
      "properties": {
        "lang": {
          "type": "string"
        },
        "content": {
          "type": "string"
        }
      },
      "required": ["lang", "content"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/RegistrationCertificateBody.schema.json",
    "fileMatch": ["a://b/RegistrationCertificateBody*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/RegistrationCertificateBody.schema.json",
      "title": "RegistrationCertificateBody",
      "type": "object",
      "properties": {
        "privacy_policy": {
          "type": "string"
        },
        "support_uri": {
          "type": "string"
        },
        "intermediary": {
          "type": "string"
        },
        "purpose": {
          "type": "array",
          "items": {
            "$ref": "./RegistrationCertificatePurpose.schema.json"
          }
        },
        "credentials": {
          "type": "array",
          "items": {
            "type": "object"
          }
        },
        "provided_attestations": {
          "type": "array",
          "items": {
            "type": "object"
          }
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/RegistrationCertificateRequest.schema.json",
    "fileMatch": ["a://b/RegistrationCertificateRequest*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/RegistrationCertificateRequest.schema.json",
      "title": "RegistrationCertificateRequest",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Optional registrar-side certificate identifier.\nIf provided and still valid, EUDIPLO reuses it instead of creating a new certificate."
        },
        "body": {
          "description": "Registration certificate creation payload.\nThis is merged with tenant-level registrar defaults when a certificate is created.",
          "allOf": [
            {
              "$ref": "./RegistrationCertificateBody.schema.json"
            }
          ]
        },
        "jwt": {
          "type": "string",
          "description": "Optional pre-existing registration certificate JWT.\nIf provided, EUDIPLO forwards it as-is and does not create a new one."
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/PresentationAttachment.schema.json",
    "fileMatch": ["a://b/PresentationAttachment*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/PresentationAttachment.schema.json",
      "title": "PresentationAttachment",
      "type": "object",
      "properties": {
        "format": {
          "type": "string"
        },
        "data": {
          "type": "object"
        },
        "credential_ids": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": ["format", "data"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/PresentationConfig.schema.json",
    "fileMatch": ["a://b/PresentationConfig*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/PresentationConfig.schema.json",
      "title": "PresentationConfig",
      "type": "object",
      "properties": {
        "registrationCertCache": {
          "type": "object",
          "nullable": true,
          "description": "Server-managed cache of the materialized registration certificate. Read-only; values supplied by clients are ignored.",
          "example": "",
          "readOnly": true,
          "additionalProperties": true
        },
        "id": {
          "type": "string",
          "description": "Unique identifier for the VP request."
        },
        "tenant": {
          "description": "The tenant that owns this object.",
          "allOf": [
            {
              "$ref": "./TenantEntity.schema.json"
            }
          ]
        },
        "description": {
          "type": "string",
          "nullable": true,
          "description": "Description of the presentation configuration."
        },
        "lifeTime": {
          "type": "number",
          "description": "Lifetime how long the presentation request is valid after creation, in seconds."
        },
        "dcql_query": {
          "description": "The DCQL query to be used for the VP request.",
          "allOf": [
            {
              "$ref": "./DCQL.schema.json"
            }
          ]
        },
        "transaction_data": {
          "type": "array",
          "items": {
            "$ref": "./TransactionData.schema.json"
          }
        },
        "registration_cert": {
          "nullable": true,
          "description": "The registration certificate request containing the necessary details.",
          "type": "object",
          "allOf": [
            {
              "$ref": "./RegistrationCertificateRequest.schema.json"
            }
          ]
        },
        "webhook": {
          "nullable": true,
          "description": "Optional webhook URL to receive the response.",
          "type": "object",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        },
        "createdAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the VP request was created."
        },
        "updatedAt": {
          "format": "date-time",
          "type": "string",
          "description": "The timestamp when the VP request was last updated."
        },
        "attached": {
          "nullable": true,
          "description": "Attestation that should be attached",
          "type": "array",
          "items": {
            "$ref": "./PresentationAttachment.schema.json"
          }
        },
        "redirectUri": {
          "type": "string",
          "nullable": true,
          "description": "Redirect URI to which the user-agent should be redirected after the presentation is completed.\nYou can use the `{sessionId}` placeholder in the URI, which will be replaced with the actual session ID.",
          "example": "https://example.com/callback?session={sessionId}"
        },
        "accessKeyChainId": {
          "type": "string",
          "nullable": true,
          "description": "Optional ID of the access certificate to use for signing the presentation request.\nIf not provided, the default access certificate for the tenant will be used.\n\nNote: This is intentionally NOT a TypeORM relationship because CertEntity uses\na composite primary key (id + tenantId), and SQLite cannot create foreign keys\nthat reference only part of a composite primary key. The relationship is handled\nat the application level in the service layer."
        }
      },
      "required": ["id", "tenant", "dcql_query", "createdAt", "updatedAt"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ResolveIssuerMetadataDto.schema.json",
    "fileMatch": ["a://b/ResolveIssuerMetadataDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ResolveIssuerMetadataDto.schema.json",
      "title": "ResolveIssuerMetadataDto",
      "type": "object",
      "properties": {
        "issuerUrl": {
          "type": "string",
          "format": "uri",
          "description": "Issuer URL or full OpenID4VCI metadata URL to resolve server-side.",
          "example": "https://issuer.example.com/issuers/tenant-a"
        }
      },
      "required": ["issuerUrl"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ResolveSchemaMetadataDto.schema.json",
    "fileMatch": ["a://b/ResolveSchemaMetadataDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ResolveSchemaMetadataDto.schema.json",
      "title": "ResolveSchemaMetadataDto",
      "type": "object",
      "properties": {
        "schemaMetadataUrl": {
          "type": "string",
          "format": "uri",
          "description": "Schema metadata URL to resolve server-side. The response must contain a signedJwt field.",
          "example": "https://registrar.example.com/schema-metadata/5c0d7dbb-ef2e-448b-b84f-b8103575947b"
        }
      },
      "required": ["schemaMetadataUrl"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/PresentationConfigCreateDto.schema.json",
    "fileMatch": ["a://b/PresentationConfigCreateDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/PresentationConfigCreateDto.schema.json",
      "title": "PresentationConfigCreateDto",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Unique identifier for the VP request."
        },
        "description": {
          "type": "string",
          "nullable": true,
          "description": "Description of the presentation configuration."
        },
        "lifeTime": {
          "type": "number",
          "description": "Lifetime how long the presentation request is valid after creation, in seconds."
        },
        "dcql_query": {
          "description": "The DCQL query to be used for the VP request.",
          "allOf": [
            {
              "$ref": "./DCQL.schema.json"
            }
          ]
        },
        "transaction_data": {
          "type": "array",
          "items": {
            "$ref": "./TransactionData.schema.json"
          }
        },
        "registration_cert": {
          "nullable": true,
          "description": "The registration certificate request containing the necessary details.",
          "type": "object",
          "allOf": [
            {
              "$ref": "./RegistrationCertificateRequest.schema.json"
            }
          ]
        },
        "webhook": {
          "nullable": true,
          "description": "Optional webhook URL to receive the response.",
          "type": "object",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        },
        "attached": {
          "nullable": true,
          "description": "Attestation that should be attached",
          "type": "array",
          "items": {
            "$ref": "./PresentationAttachment.schema.json"
          }
        },
        "redirectUri": {
          "type": "string",
          "nullable": true,
          "description": "Redirect URI to which the user-agent should be redirected after the presentation is completed.\nYou can use the `{sessionId}` placeholder in the URI, which will be replaced with the actual session ID.",
          "example": "https://example.com/callback?session={sessionId}"
        },
        "accessKeyChainId": {
          "type": "string",
          "nullable": true,
          "description": "Optional ID of the access certificate to use for signing the presentation request.\nIf not provided, the default access certificate for the tenant will be used.\n\nNote: This is intentionally NOT a TypeORM relationship because CertEntity uses\na composite primary key (id + tenantId), and SQLite cannot create foreign keys\nthat reference only part of a composite primary key. The relationship is handled\nat the application level in the service layer."
        }
      },
      "required": ["id", "dcql_query"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/PresentationConfigUpdateDto.schema.json",
    "fileMatch": ["a://b/PresentationConfigUpdateDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/PresentationConfigUpdateDto.schema.json",
      "title": "PresentationConfigUpdateDto",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Unique identifier for the VP request."
        },
        "description": {
          "type": "string",
          "nullable": true,
          "description": "Description of the presentation configuration."
        },
        "lifeTime": {
          "type": "number",
          "description": "Lifetime how long the presentation request is valid after creation, in seconds."
        },
        "dcql_query": {
          "description": "The DCQL query to be used for the VP request.",
          "allOf": [
            {
              "$ref": "./DCQL.schema.json"
            }
          ]
        },
        "transaction_data": {
          "type": "array",
          "items": {
            "$ref": "./TransactionData.schema.json"
          }
        },
        "registration_cert": {
          "nullable": true,
          "description": "The registration certificate request containing the necessary details.",
          "type": "object",
          "allOf": [
            {
              "$ref": "./RegistrationCertificateRequest.schema.json"
            }
          ]
        },
        "webhook": {
          "nullable": true,
          "description": "Optional webhook URL to receive the response.",
          "type": "object",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        },
        "attached": {
          "nullable": true,
          "description": "Attestation that should be attached",
          "type": "array",
          "items": {
            "$ref": "./PresentationAttachment.schema.json"
          }
        },
        "redirectUri": {
          "type": "string",
          "nullable": true,
          "description": "Redirect URI to which the user-agent should be redirected after the presentation is completed.\nYou can use the `{sessionId}` placeholder in the URI, which will be replaced with the actual session ID.",
          "example": "https://example.com/callback?session={sessionId}"
        },
        "accessKeyChainId": {
          "type": "string",
          "nullable": true,
          "description": "Optional ID of the access certificate to use for signing the presentation request.\nIf not provided, the default access certificate for the tenant will be used.\n\nNote: This is intentionally NOT a TypeORM relationship because CertEntity uses\na composite primary key (id + tenantId), and SQLite cannot create foreign keys\nthat reference only part of a composite primary key. The relationship is handled\nat the application level in the service layer."
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/RegistrationCertificateDefaults.schema.json",
    "fileMatch": ["a://b/RegistrationCertificateDefaults*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/RegistrationCertificateDefaults.schema.json",
      "title": "RegistrationCertificateDefaults",
      "type": "object",
      "properties": {
        "privacy_policy": {
          "type": "string",
          "description": "Default privacy policy URL for registration certificate creation.",
          "example": "https://verifier.example/privacy"
        },
        "support_uri": {
          "type": "string",
          "description": "Default support contact URI for registration certificate creation.",
          "example": "mailto:support@verifier.example"
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/RegistrarConfigResponseDto.schema.json",
    "fileMatch": ["a://b/RegistrarConfigResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/RegistrarConfigResponseDto.schema.json",
      "title": "RegistrarConfigResponseDto",
      "type": "object",
      "properties": {
        "registrarUrl": {
          "type": "string",
          "description": "The base URL of the registrar API",
          "example": "https://sandbox.eudi-wallet.org/api"
        },
        "oidcUrl": {
          "type": "string",
          "description": "The OIDC issuer URL for authentication (e.g., Keycloak realm URL)",
          "example": "https://auth.example.com/realms/my-realm"
        },
        "clientId": {
          "type": "string",
          "description": "The OIDC client ID for the registrar",
          "example": "registrar-client"
        },
        "clientSecret": {
          "type": "string",
          "description": "The OIDC client secret (optional, for confidential clients)"
        },
        "username": {
          "type": "string",
          "description": "The username for OIDC login",
          "example": "admin@example.com"
        },
        "registrationCertificateDefaults": {
          "nullable": true,
          "description": "Optional default values merged into registration certificate creation requests (for example privacy_policy, support_uri)",
          "additionalProperties": true,
          "type": "object",
          "allOf": [
            {
              "$ref": "./RegistrationCertificateDefaults.schema.json"
            }
          ]
        },
        "hasPassword": {
          "type": "boolean",
          "description": "Indicates whether a password is configured (actual password is never returned)",
          "example": true
        }
      },
      "required": ["registrarUrl", "oidcUrl", "clientId", "username", "hasPassword"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/CreateRegistrarConfigDto.schema.json",
    "fileMatch": ["a://b/CreateRegistrarConfigDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/CreateRegistrarConfigDto.schema.json",
      "title": "CreateRegistrarConfigDto",
      "type": "object",
      "properties": {
        "registrarUrl": {
          "type": "string",
          "description": "The base URL of the registrar API",
          "example": "https://sandbox.eudi-wallet.org/api"
        },
        "oidcUrl": {
          "type": "string",
          "description": "The OIDC issuer URL for authentication (e.g., Keycloak realm URL)",
          "example": "https://auth.example.com/realms/my-realm"
        },
        "clientId": {
          "type": "string",
          "description": "The OIDC client ID for the registrar",
          "example": "registrar-client"
        },
        "clientSecret": {
          "type": "string",
          "description": "The OIDC client secret (optional, for confidential clients)"
        },
        "username": {
          "type": "string",
          "description": "The username for OIDC login",
          "example": "admin@example.com"
        },
        "password": {
          "type": "string",
          "description": "The password for OIDC login (stored in plaintext)"
        },
        "registrationCertificateDefaults": {
          "nullable": true,
          "description": "Optional default values merged into registration certificate creation requests (for example privacy_policy, support_uri)",
          "additionalProperties": true,
          "type": "object",
          "allOf": [
            {
              "$ref": "./RegistrationCertificateDefaults.schema.json"
            }
          ]
        }
      },
      "required": ["registrarUrl", "oidcUrl", "clientId", "username", "password"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/UpdateRegistrarConfigDto.schema.json",
    "fileMatch": ["a://b/UpdateRegistrarConfigDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/UpdateRegistrarConfigDto.schema.json",
      "title": "UpdateRegistrarConfigDto",
      "type": "object",
      "properties": {
        "registrarUrl": {
          "type": "string",
          "description": "The base URL of the registrar API",
          "example": "https://sandbox.eudi-wallet.org/api"
        },
        "oidcUrl": {
          "type": "string",
          "description": "The OIDC issuer URL for authentication (e.g., Keycloak realm URL)",
          "example": "https://auth.example.com/realms/my-realm"
        },
        "clientId": {
          "type": "string",
          "description": "The OIDC client ID for the registrar",
          "example": "registrar-client"
        },
        "clientSecret": {
          "type": "string",
          "description": "The OIDC client secret (optional, for confidential clients)"
        },
        "username": {
          "type": "string",
          "description": "The username for OIDC login",
          "example": "admin@example.com"
        },
        "password": {
          "type": "string",
          "description": "The password for OIDC login (stored in plaintext)"
        },
        "registrationCertificateDefaults": {
          "nullable": true,
          "description": "Optional default values merged into registration certificate creation requests (for example privacy_policy, support_uri)",
          "additionalProperties": true,
          "type": "object",
          "allOf": [
            {
              "$ref": "./RegistrationCertificateDefaults.schema.json"
            }
          ]
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/CreateAccessCertificateDto.schema.json",
    "fileMatch": ["a://b/CreateAccessCertificateDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/CreateAccessCertificateDto.schema.json",
      "title": "CreateAccessCertificateDto",
      "type": "object",
      "properties": {
        "keyId": {
          "type": "string",
          "description": "The ID of the key to create an access certificate for",
          "example": "my-signing-key"
        }
      },
      "required": ["keyId"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/DeferredCredentialRequestDto.schema.json",
    "fileMatch": ["a://b/DeferredCredentialRequestDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/DeferredCredentialRequestDto.schema.json",
      "title": "DeferredCredentialRequestDto",
      "type": "object",
      "properties": {
        "transaction_id": {
          "type": "string",
          "description": "The transaction identifier previously returned by the Credential Endpoint",
          "example": "8xLOxBtZp8"
        }
      },
      "required": ["transaction_id"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/NotificationRequestDto.schema.json",
    "fileMatch": ["a://b/NotificationRequestDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/NotificationRequestDto.schema.json",
      "title": "NotificationRequestDto",
      "type": "object",
      "properties": {
        "notification_id": {
          "type": "string"
        },
        "event": {
          "type": "string",
          "enum": ["credential_accepted", "credential_failure", "credential_deleted"]
        }
      },
      "required": ["notification_id", "event"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/Object.schema.json",
    "fileMatch": ["a://b/Object*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/Object.schema.json",
      "title": "Object",
      "type": "object",
      "properties": {},
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ParResponseDto.schema.json",
    "fileMatch": ["a://b/ParResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ParResponseDto.schema.json",
      "title": "ParResponseDto",
      "type": "object",
      "properties": {
        "request_uri": {
          "type": "string",
          "description": "The request URI for the Pushed Authorization Request."
        },
        "expires_in": {
          "type": "number",
          "description": "The expiration time for the request URI in seconds."
        }
      },
      "required": ["request_uri", "expires_in"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/InteractiveAuthorizationRequestDto.schema.json",
    "fileMatch": ["a://b/InteractiveAuthorizationRequestDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/InteractiveAuthorizationRequestDto.schema.json",
      "title": "InteractiveAuthorizationRequestDto",
      "type": "object",
      "properties": {
        "response_type": {
          "type": "string",
          "description": "Response type (for initial request)"
        },
        "client_id": {
          "type": "string",
          "description": "Client identifier (for initial request)"
        },
        "interaction_types_supported": {
          "type": "string",
          "description": "Comma-separated list of supported interaction types (for initial request)"
        },
        "redirect_uri": {
          "type": "string",
          "description": "Redirect URI (for initial request)"
        },
        "scope": {
          "type": "string",
          "description": "OAuth scope"
        },
        "code_challenge": {
          "type": "string",
          "description": "PKCE code challenge"
        },
        "code_challenge_method": {
          "type": "string",
          "description": "PKCE code challenge method"
        },
        "authorization_details": {
          "type": "object",
          "description": "Authorization details"
        },
        "state": {
          "type": "string",
          "description": "State parameter"
        },
        "issuer_state": {
          "type": "string",
          "description": "Issuer state from credential offer"
        },
        "auth_session": {
          "type": "string",
          "description": "Auth session identifier (for follow-up request)"
        },
        "openid4vp_response": {
          "type": "string",
          "description": "OpenID4VP response (for follow-up request)"
        },
        "code_verifier": {
          "type": "string",
          "description": "PKCE code verifier (for follow-up request)"
        },
        "request": {
          "type": "string",
          "description": "JAR request JWT (by value)"
        },
        "request_uri": {
          "type": "string",
          "description": "JAR request URI (by reference)"
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/InteractiveAuthorizationCodeResponseDto.schema.json",
    "fileMatch": ["a://b/InteractiveAuthorizationCodeResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/InteractiveAuthorizationCodeResponseDto.schema.json",
      "title": "InteractiveAuthorizationCodeResponseDto",
      "type": "object",
      "properties": {
        "status": {
          "type": "string",
          "description": "Response status",
          "example": "ok"
        },
        "code": {
          "type": "string",
          "description": "Authorization code",
          "example": "auth-code-123"
        }
      },
      "required": ["status", "code"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/InteractiveAuthorizationErrorResponseDto.schema.json",
    "fileMatch": ["a://b/InteractiveAuthorizationErrorResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/InteractiveAuthorizationErrorResponseDto.schema.json",
      "title": "InteractiveAuthorizationErrorResponseDto",
      "type": "object",
      "properties": {
        "error": {
          "type": "string",
          "description": "OAuth error code",
          "example": "invalid_request"
        },
        "error_description": {
          "type": "string",
          "description": "Human-readable error description",
          "example": "Missing required parameter: interaction_types_supported"
        }
      },
      "required": ["error"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ChainedAsParResponseDto.schema.json",
    "fileMatch": ["a://b/ChainedAsParResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ChainedAsParResponseDto.schema.json",
      "title": "ChainedAsParResponseDto",
      "type": "object",
      "properties": {
        "request_uri": {
          "type": "string",
          "description": "The request URI to use at the authorization endpoint",
          "example": "urn:ietf:params:oauth:request_uri:abc123"
        },
        "expires_in": {
          "type": "number",
          "description": "The lifetime of the request URI in seconds",
          "example": 600
        }
      },
      "required": ["request_uri", "expires_in"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ChainedAsErrorResponseDto.schema.json",
    "fileMatch": ["a://b/ChainedAsErrorResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ChainedAsErrorResponseDto.schema.json",
      "title": "ChainedAsErrorResponseDto",
      "type": "object",
      "properties": {
        "error": {
          "type": "string",
          "description": "Error code",
          "example": "invalid_request"
        },
        "error_description": {
          "type": "string",
          "description": "Human-readable error description"
        }
      },
      "required": ["error"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ChainedAsTokenRequestDto.schema.json",
    "fileMatch": ["a://b/ChainedAsTokenRequestDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ChainedAsTokenRequestDto.schema.json",
      "title": "ChainedAsTokenRequestDto",
      "type": "object",
      "properties": {
        "grant_type": {
          "type": "string",
          "description": "Grant type ('authorization_code' or 'refresh_token')",
          "example": "authorization_code"
        },
        "code": {
          "type": "string",
          "description": "Authorization code received in the callback (authorization_code grant)"
        },
        "refresh_token": {
          "type": "string",
          "description": "Refresh token (refresh_token grant)"
        },
        "client_id": {
          "type": "string",
          "description": "Client identifier"
        },
        "redirect_uri": {
          "type": "string",
          "description": "Redirect URI (must match the one used in PAR)"
        },
        "code_verifier": {
          "type": "string",
          "description": "PKCE code verifier"
        }
      },
      "required": ["grant_type"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ChainedAsTokenResponseDto.schema.json",
    "fileMatch": ["a://b/ChainedAsTokenResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ChainedAsTokenResponseDto.schema.json",
      "title": "ChainedAsTokenResponseDto",
      "type": "object",
      "properties": {
        "access_token": {
          "type": "string",
          "description": "The access token"
        },
        "token_type": {
          "type": "string",
          "description": "Token type (Bearer or DPoP)",
          "example": "DPoP"
        },
        "expires_in": {
          "type": "number",
          "description": "Token lifetime in seconds",
          "example": 3600
        },
        "scope": {
          "type": "string",
          "description": "Scope granted"
        },
        "authorization_details": {
          "description": "Authorized credential configurations",
          "type": "array",
          "items": {
            "type": "object"
          }
        },
        "c_nonce": {
          "type": "string",
          "description": "C_NONCE for credential request"
        },
        "c_nonce_expires_in": {
          "type": "number",
          "description": "C_NONCE lifetime in seconds"
        },
        "refresh_token": {
          "type": "string",
          "description": "Refresh token (issued when refresh tokens are enabled)"
        }
      },
      "required": ["access_token", "token_type", "expires_in"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/OfferResponse.schema.json",
    "fileMatch": ["a://b/OfferResponse*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/OfferResponse.schema.json",
      "title": "OfferResponse",
      "type": "object",
      "properties": {
        "uri": {
          "type": "string"
        },
        "crossDeviceUri": {
          "type": "string",
          "description": "URI for cross-device flows (no redirect after completion)"
        },
        "session": {
          "type": "string"
        }
      },
      "required": ["uri", "session"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/CompleteDeferredDto.schema.json",
    "fileMatch": ["a://b/CompleteDeferredDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/CompleteDeferredDto.schema.json",
      "title": "CompleteDeferredDto",
      "type": "object",
      "properties": {
        "claims": {
          "type": "object",
          "description": "Claims to include in the credential. The structure should match the credential configuration's expected claims.",
          "example": {
            "given_name": "John",
            "family_name": "Doe",
            "birthdate": "1990-01-15"
          }
        }
      },
      "required": ["claims"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/DeferredOperationResponse.schema.json",
    "fileMatch": ["a://b/DeferredOperationResponse*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/DeferredOperationResponse.schema.json",
      "title": "DeferredOperationResponse",
      "type": "object",
      "properties": {
        "transactionId": {
          "type": "string",
          "description": "The transaction ID"
        },
        "status": {
          "description": "The new status of the transaction",
          "enum": ["pending", "ready", "retrieved", "expired", "failed"],
          "type": "string"
        },
        "message": {
          "type": "string",
          "description": "Optional message"
        }
      },
      "required": ["transactionId", "status"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/FailDeferredDto.schema.json",
    "fileMatch": ["a://b/FailDeferredDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/FailDeferredDto.schema.json",
      "title": "FailDeferredDto",
      "type": "object",
      "properties": {
        "error": {
          "type": "string",
          "description": "Optional error message explaining why the issuance failed",
          "example": "Identity verification failed"
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/EC_Public.schema.json",
    "fileMatch": ["a://b/EC_Public*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/EC_Public.schema.json",
      "title": "EC_Public",
      "type": "object",
      "properties": {
        "kty": {
          "type": "string",
          "description": "The key type, which is always 'EC' for Elliptic Curve keys."
        },
        "crv": {
          "type": "string",
          "description": "The algorithm intended for use with the key, such as 'ES256'."
        },
        "x": {
          "type": "string",
          "description": "The x coordinate of the EC public key."
        },
        "y": {
          "type": "string",
          "description": "The y coordinate of the EC public key."
        }
      },
      "required": ["kty", "crv", "x", "y"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/JwksResponseDto.schema.json",
    "fileMatch": ["a://b/JwksResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/JwksResponseDto.schema.json",
      "title": "JwksResponseDto",
      "type": "object",
      "properties": {
        "keys": {
          "description": "An array of EC public keys in JWK format.",
          "type": "array",
          "items": {
            "$ref": "./EC_Public.schema.json"
          }
        }
      },
      "required": ["keys"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/AuthorizationResponse.schema.json",
    "fileMatch": ["a://b/AuthorizationResponse*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/AuthorizationResponse.schema.json",
      "title": "AuthorizationResponse",
      "type": "object",
      "properties": {
        "response": {
          "type": "string",
          "description": "The response string containing the authorization details (JWE-encrypted VP token).\nRequired for success responses, absent for error responses."
        },
        "sendResponse": {
          "type": "boolean",
          "description": "When set to true, the authorization response will be sent to the client."
        },
        "error": {
          "type": "string"
        },
        "error_description": {
          "type": "string",
          "description": "Human-readable description of the error."
        },
        "error_uri": {
          "type": "string",
          "description": "URI with additional information about the error."
        },
        "state": {
          "type": "string",
          "description": "State value from the authorization request (for correlation)."
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/KmsProviderCapabilitiesDto.schema.json",
    "fileMatch": ["a://b/KmsProviderCapabilitiesDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/KmsProviderCapabilitiesDto.schema.json",
      "title": "KmsProviderCapabilitiesDto",
      "type": "object",
      "properties": {
        "canImport": {
          "type": "boolean",
          "description": "Whether the provider supports importing existing keys.",
          "example": true
        },
        "canCreate": {
          "type": "boolean",
          "description": "Whether the provider supports generating new keys.",
          "example": true
        },
        "canDelete": {
          "type": "boolean",
          "description": "Whether the provider supports deleting keys.",
          "example": true
        },
        "supportedAlgs": {
          "description": "Signing algorithms supported by the provider.",
          "example": ["ES256"],
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "defaultAlg": {
          "type": "string",
          "description": "Default signing algorithm used when caller does not specify one.",
          "example": "ES256"
        }
      },
      "required": ["canImport", "canCreate", "canDelete", "supportedAlgs", "defaultAlg"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/KmsProviderInfoDto.schema.json",
    "fileMatch": ["a://b/KmsProviderInfoDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/KmsProviderInfoDto.schema.json",
      "title": "KmsProviderInfoDto",
      "type": "object",
      "properties": {
        "name": {
          "type": "string",
          "description": "Unique provider ID (matches the id in kms.json).",
          "example": "main-vault"
        },
        "type": {
          "type": "string",
          "description": "Type of the KMS provider (db, vault, aws-kms).",
          "example": "vault"
        },
        "description": {
          "type": "string",
          "description": "Human-readable description of this provider instance.",
          "example": "Production HashiCorp Vault"
        },
        "capabilities": {
          "description": "Capabilities of this provider.",
          "allOf": [
            {
              "$ref": "./KmsProviderCapabilitiesDto.schema.json"
            }
          ]
        }
      },
      "required": ["name", "type", "capabilities"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/KmsProvidersResponseDto.schema.json",
    "fileMatch": ["a://b/KmsProvidersResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/KmsProvidersResponseDto.schema.json",
      "title": "KmsProvidersResponseDto",
      "type": "object",
      "properties": {
        "providers": {
          "description": "Detailed info for each registered KMS provider.",
          "type": "array",
          "items": {
            "$ref": "./KmsProviderInfoDto.schema.json"
          }
        },
        "default": {
          "type": "string",
          "description": "The default KMS provider name.",
          "example": "db"
        }
      },
      "required": ["providers", "default"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/CertificateInfoDto.schema.json",
    "fileMatch": ["a://b/CertificateInfoDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/CertificateInfoDto.schema.json",
      "title": "CertificateInfoDto",
      "type": "object",
      "properties": {
        "pem": {
          "type": "string",
          "description": "Certificate in PEM format."
        },
        "subject": {
          "type": "string",
          "description": "Certificate subject (CN)."
        },
        "issuer": {
          "type": "string",
          "description": "Certificate issuer (CN)."
        },
        "notBefore": {
          "format": "date-time",
          "type": "string",
          "description": "Certificate not before date."
        },
        "notAfter": {
          "format": "date-time",
          "type": "string",
          "description": "Certificate not after date."
        },
        "serialNumber": {
          "type": "string",
          "description": "Serial number."
        }
      },
      "required": ["pem"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/PublicKeyInfoDto.schema.json",
    "fileMatch": ["a://b/PublicKeyInfoDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/PublicKeyInfoDto.schema.json",
      "title": "PublicKeyInfoDto",
      "type": "object",
      "properties": {
        "kty": {
          "type": "string",
          "description": "Key type (e.g., EC).",
          "example": "EC"
        },
        "alg": {
          "type": "string",
          "description": "Key algorithm (e.g., ES256).",
          "example": "ES256"
        },
        "kid": {
          "type": "string",
          "description": "Key ID."
        },
        "crv": {
          "type": "string",
          "description": "Curve (for EC keys).",
          "example": "P-256"
        }
      },
      "required": ["kty"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/RotationPolicyResponseDto.schema.json",
    "fileMatch": ["a://b/RotationPolicyResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/RotationPolicyResponseDto.schema.json",
      "title": "RotationPolicyResponseDto",
      "type": "object",
      "properties": {
        "enabled": {
          "type": "boolean",
          "description": "Whether automatic key rotation is enabled."
        },
        "intervalDays": {
          "type": "number",
          "description": "Rotation interval in days."
        },
        "certValidityDays": {
          "type": "number",
          "description": "Certificate validity in days."
        },
        "nextRotationAt": {
          "format": "date-time",
          "type": "string",
          "description": "Next scheduled rotation date."
        }
      },
      "required": ["enabled"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/KeyChainResponseDto.schema.json",
    "fileMatch": ["a://b/KeyChainResponseDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/KeyChainResponseDto.schema.json",
      "title": "KeyChainResponseDto",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Unique identifier for the key chain."
        },
        "usageType": {
          "enum": ["access", "attestation", "trustList", "statusList", "encrypt"],
          "type": "string",
          "description": "Usage type of the key chain."
        },
        "type": {
          "enum": ["standalone", "internalChain"],
          "type": "string",
          "description": "Type of key chain (standalone or internalChain)."
        },
        "description": {
          "type": "string",
          "description": "Human-readable description."
        },
        "kmsProvider": {
          "type": "string",
          "description": "KMS provider used for this key chain."
        },
        "rootCertificate": {
          "description": "Root CA certificate (only for internalChain type).",
          "allOf": [
            {
              "$ref": "./CertificateInfoDto.schema.json"
            }
          ]
        },
        "activePublicKey": {
          "description": "Active signing key's public key info.",
          "allOf": [
            {
              "$ref": "./PublicKeyInfoDto.schema.json"
            }
          ]
        },
        "activeCertificate": {
          "description": "Active signing key's certificate. Not present for encryption keys.",
          "allOf": [
            {
              "$ref": "./CertificateInfoDto.schema.json"
            }
          ]
        },
        "previousPublicKey": {
          "description": "Previous signing key's public key info (if in grace period).",
          "allOf": [
            {
              "$ref": "./PublicKeyInfoDto.schema.json"
            }
          ]
        },
        "previousCertificate": {
          "description": "Previous signing key's certificate (if in grace period).",
          "allOf": [
            {
              "$ref": "./CertificateInfoDto.schema.json"
            }
          ]
        },
        "previousKeyExpiry": {
          "format": "date-time",
          "type": "string",
          "description": "Previous key expiry date."
        },
        "rotationPolicy": {
          "description": "Rotation policy configuration.",
          "allOf": [
            {
              "$ref": "./RotationPolicyResponseDto.schema.json"
            }
          ]
        },
        "createdAt": {
          "format": "date-time",
          "type": "string",
          "description": "Timestamp when the key chain was created."
        },
        "updatedAt": {
          "format": "date-time",
          "type": "string",
          "description": "Timestamp when the key chain was last updated."
        }
      },
      "required": [
        "id",
        "usageType",
        "type",
        "kmsProvider",
        "activePublicKey",
        "rotationPolicy",
        "createdAt",
        "updatedAt"
      ],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ExportEcJwk.schema.json",
    "fileMatch": ["a://b/ExportEcJwk*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ExportEcJwk.schema.json",
      "title": "ExportEcJwk",
      "type": "object",
      "properties": {
        "kty": {
          "type": "string",
          "description": "Key type",
          "example": "EC"
        },
        "crv": {
          "type": "string",
          "description": "Curve",
          "example": "P-256"
        },
        "x": {
          "type": "string",
          "description": "X coordinate (base64url)"
        },
        "y": {
          "type": "string",
          "description": "Y coordinate (base64url)"
        },
        "d": {
          "type": "string",
          "description": "Private key (base64url)"
        },
        "alg": {
          "type": "string",
          "description": "Algorithm",
          "example": "ES256"
        },
        "kid": {
          "type": "string",
          "description": "Key ID"
        }
      },
      "required": ["kty", "crv", "x", "y", "d"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ExportRotationPolicyDto.schema.json",
    "fileMatch": ["a://b/ExportRotationPolicyDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/ExportRotationPolicyDto.schema.json",
      "title": "ExportRotationPolicyDto",
      "type": "object",
      "properties": {
        "enabled": {
          "type": "boolean",
          "description": "Whether rotation is enabled."
        },
        "intervalDays": {
          "type": "number",
          "description": "Rotation interval in days."
        },
        "certValidityDays": {
          "type": "number",
          "description": "Certificate validity in days."
        }
      },
      "required": ["enabled"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/KeyChainExportDto.schema.json",
    "fileMatch": ["a://b/KeyChainExportDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/KeyChainExportDto.schema.json",
      "title": "KeyChainExportDto",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "Key chain ID."
        },
        "description": {
          "type": "string",
          "description": "Human-readable description."
        },
        "usageType": {
          "enum": ["access", "attestation", "trustList", "statusList", "encrypt"],
          "type": "string",
          "description": "Usage type for this key chain."
        },
        "key": {
          "description": "The private key in JWK format (EC).",
          "allOf": [
            {
              "$ref": "./ExportEcJwk.schema.json"
            }
          ]
        },
        "crt": {
          "description": "Certificate chain in PEM format (leaf first, then intermediates/CA).",
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "kmsProvider": {
          "type": "string",
          "description": "KMS provider name."
        },
        "rotationPolicy": {
          "description": "Rotation policy.",
          "allOf": [
            {
              "$ref": "./ExportRotationPolicyDto.schema.json"
            }
          ]
        }
      },
      "required": ["id", "usageType", "key"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/RotationPolicyCreateDto.schema.json",
    "fileMatch": ["a://b/RotationPolicyCreateDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/RotationPolicyCreateDto.schema.json",
      "title": "RotationPolicyCreateDto",
      "type": "object",
      "properties": {
        "enabled": {
          "type": "boolean",
          "description": "Whether automatic key rotation is enabled.",
          "default": false
        },
        "intervalDays": {
          "type": "number",
          "minimum": 1,
          "maximum": 3650,
          "description": "Rotation interval in days. Required when enabled is true.",
          "example": 90
        },
        "certValidityDays": {
          "type": "number",
          "minimum": 1,
          "maximum": 3650,
          "description": "Certificate validity in days. Defaults to rotation interval + 30 days grace period.",
          "example": 365
        }
      },
      "required": ["enabled"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/KeyChainCreateDto.schema.json",
    "fileMatch": ["a://b/KeyChainCreateDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/KeyChainCreateDto.schema.json",
      "title": "KeyChainCreateDto",
      "type": "object",
      "properties": {
        "usageType": {
          "enum": ["access", "attestation", "trustList", "statusList", "encrypt"],
          "type": "string",
          "description": "Usage type determines the purpose of this key chain (access, attestation, etc.).",
          "example": "attestation"
        },
        "type": {
          "enum": ["standalone", "internalChain"],
          "type": "string",
          "description": "Type of key chain to create.",
          "example": "internalChain"
        },
        "description": {
          "type": "string",
          "description": "Human-readable description for the key chain.",
          "example": "Production credential signing key"
        },
        "kmsProvider": {
          "type": "string",
          "description": "KMS provider to use (defaults to the configured default provider).",
          "example": "vault"
        },
        "rotationPolicy": {
          "description": "Rotation policy configuration. Only applicable for the signing key (root CA never rotates).",
          "allOf": [
            {
              "$ref": "./RotationPolicyCreateDto.schema.json"
            }
          ]
        }
      },
      "required": ["usageType", "type"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/EcJwk.schema.json",
    "fileMatch": ["a://b/EcJwk*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/EcJwk.schema.json",
      "title": "EcJwk",
      "type": "object",
      "properties": {
        "kty": {
          "type": "string"
        },
        "x": {
          "type": "string"
        },
        "y": {
          "type": "string"
        },
        "crv": {
          "type": "string"
        },
        "d": {
          "type": "string"
        },
        "alg": {
          "type": "string"
        },
        "kid": {
          "type": "string"
        }
      },
      "required": ["kty", "x", "y", "crv", "d"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/RotationPolicyImportDto.schema.json",
    "fileMatch": ["a://b/RotationPolicyImportDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/RotationPolicyImportDto.schema.json",
      "title": "RotationPolicyImportDto",
      "type": "object",
      "properties": {
        "enabled": {
          "type": "boolean",
          "description": "Whether rotation is enabled. When true, the imported key becomes a root CA.",
          "default": false
        },
        "intervalDays": {
          "type": "number",
          "minimum": 1,
          "maximum": 3650,
          "description": "Rotation interval in days.",
          "example": 90
        },
        "certValidityDays": {
          "type": "number",
          "minimum": 1,
          "maximum": 3650,
          "description": "Certificate validity in days.",
          "example": 365
        }
      },
      "required": ["enabled"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/KeyChainImportDto.schema.json",
    "fileMatch": ["a://b/KeyChainImportDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/KeyChainImportDto.schema.json",
      "title": "KeyChainImportDto",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "description": "ID for the key chain. If not provided, a new UUID will be generated."
        },
        "key": {
          "description": "The private key in JWK format.",
          "allOf": [
            {
              "$ref": "./EcJwk.schema.json"
            }
          ]
        },
        "description": {
          "type": "string",
          "description": "Human-readable description."
        },
        "usageType": {
          "enum": ["access", "attestation", "trustList", "statusList", "encrypt"],
          "type": "string",
          "description": "Usage type for this key chain."
        },
        "crt": {
          "description": "Certificate chain in PEM format (leaf first, then intermediates/CA).",
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "kmsProvider": {
          "type": "string",
          "description": "KMS provider to use. Defaults to 'db'."
        },
        "rotationPolicy": {
          "description": "Rotation policy. When enabled, the imported key becomes a root CA and a new leaf key is generated.",
          "allOf": [
            {
              "$ref": "./RotationPolicyImportDto.schema.json"
            }
          ]
        }
      },
      "required": ["key", "usageType"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/RotationPolicyUpdateDto.schema.json",
    "fileMatch": ["a://b/RotationPolicyUpdateDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/RotationPolicyUpdateDto.schema.json",
      "title": "RotationPolicyUpdateDto",
      "type": "object",
      "properties": {
        "enabled": {
          "type": "boolean",
          "description": "Whether automatic key rotation is enabled."
        },
        "intervalDays": {
          "type": "number",
          "minimum": 1,
          "maximum": 3650,
          "description": "Rotation interval in days."
        },
        "certValidityDays": {
          "type": "number",
          "minimum": 1,
          "maximum": 3650,
          "description": "Certificate validity in days."
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/KeyChainUpdateDto.schema.json",
    "fileMatch": ["a://b/KeyChainUpdateDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/KeyChainUpdateDto.schema.json",
      "title": "KeyChainUpdateDto",
      "type": "object",
      "properties": {
        "description": {
          "type": "string",
          "description": "Human-readable description for the key chain."
        },
        "rotationPolicy": {
          "description": "Rotation policy configuration.",
          "allOf": [
            {
              "$ref": "./RotationPolicyUpdateDto.schema.json"
            }
          ]
        },
        "activeCertificate": {
          "type": "string",
          "description": "Active certificate chain in PEM format. Used for external certificate updates."
        }
      },
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/PresentationRequest.schema.json",
    "fileMatch": ["a://b/PresentationRequest*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/PresentationRequest.schema.json",
      "title": "PresentationRequest",
      "type": "object",
      "properties": {
        "response_type": {
          "type": "string",
          "description": "The type of response expected from the presentation request.",
          "enum": ["uri", "dc-api"]
        },
        "requestId": {
          "type": "string",
          "description": "Identifier of the presentation configuration"
        },
        "webhook": {
          "description": "Webhook configuration to receive the response.\nIf not provided, the configured webhook from the configuration will be used.",
          "allOf": [
            {
              "$ref": "./WebhookConfig.schema.json"
            }
          ]
        },
        "redirectUri": {
          "type": "string",
          "description": "Optional redirect URI to which the user-agent should be redirected after the presentation is completed.\nYou can use the `{sessionId}` placeholder in the URI, which will be replaced with the actual session ID.",
          "example": "https://example.com/callback?session={sessionId}"
        },
        "transaction_data": {
          "description": "Optional transaction data to include in the OID4VP request.\nIf provided, this will override the transaction_data from the presentation configuration.",
          "type": "array",
          "items": {
            "$ref": "./TransactionData.schema.json"
          }
        }
      },
      "required": ["response_type", "requestId"],
      "additionalProperties": false
    }
  },
  {
    "uri": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/FileUploadDto.schema.json",
    "fileMatch": ["a://b/FileUploadDto*.schema.json"],
    "schema": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "$id": "https://raw.githubusercontent.com/openwallet-foundation/eudiplo/refs/heads/main/schemas/FileUploadDto.schema.json",
      "title": "FileUploadDto",
      "type": "object",
      "properties": {
        "file": {
          "type": "string",
          "format": "binary"
        }
      },
      "required": ["file"],
      "additionalProperties": false
    }
  }
]
